/**
 * English (en) - Base translations
 * All keys defined here, other languages inherit from this
 */
export default {
  // Navigation
  dashboard: 'Dashboard',
  employees: 'Employees',
  shifts: 'Shifts',
  schedule: 'Schedule',
  reports: 'Reports',
  settings: 'Settings',
  notifications: 'Notifications',
  logout: 'Logout',
  crm: 'CRM',
  erp: 'ERP',
  analytics: 'Analytics',
  domains: 'Domains',
  integrations: 'Integrations',
  templates: 'Templates',
  rules: 'Rules',
  swaps: 'Swaps',
  geofencing: 'Geofencing',
  aiScheduling: 'AI Scheduling',
  locations: 'Locations',
  chat: 'Chat',
  leave: 'Leave',
  vacations: 'Vacations',
  rewards: 'Rewards',
  gamification: 'Gamification',
  documents: 'Documents',
  signatures: 'Signatures',
  predictions: 'Predictions',
  aiPredictions: 'AI Predictions',
  whatsapp: 'WhatsApp',
  securityAlerts: 'Security Alerts',
  compliance: 'Compliance',
  mobileApp: 'Mobile App',
  aiAutoAssign: 'AI Auto-Assign',

  // Auth
  login: 'Login',
  register: 'Register',
  email: 'Email',
  password: 'Password',
  confirmPassword: 'Confirm Password',
  firstName: 'First Name',
  lastName: 'Last Name',
  phone: 'Phone',
  forgotPassword: 'Forgot Password?',
  noAccount: "Don't have an account?",
  haveAccount: 'Already have an account?',
  twoFactorAuth: 'Two-Factor Authentication',
  enterCode: 'Enter the code from your authenticator app',
  verify: 'Verify',

  // Dashboard
  welcome: 'Welcome',
  hello: 'Hello',
  yourSummaryToday: 'Your summary for today',
  organizationSummary: 'Summary of your organization',
  totalEmployees: 'Total Employees',
  todaysShifts: "Today's Shifts",
  openShifts: 'Open Shifts',
  scheduledHours: 'Scheduled Hours',
  hoursThisWeek: 'Hours This Week',
  upcomingShifts: 'Upcoming Shifts',
  quickActions: 'Quick Actions',
  addEmployee: 'Add Employee',
  createShift: 'Create Shift',
  viewSchedule: 'View Schedule',
  currentStreak: 'Current Streak',
  points: 'Points',
  level: 'Level',
  days: 'days',
  nextShift: 'Next Shift',
  scheduledShift: 'Scheduled Shift',
  clockInNow: 'Clock In Now',
  viewAll: 'View All',
  newShift: 'New Shift',
  shiftsThisWeek: 'Shifts This Week',
  totalHours: 'Total Hours',
  attendance: 'Attendance',
  noShiftsToday: 'No shifts for today',
  viewReports: 'View Reports',
  alerts: 'Alerts',
  allSystemsOk: 'Everything working correctly. No important alerts.',
  employee: 'Employee',
  shift: 'Shift',
  pending: 'Pending',
  confirmed: 'Confirmed',
  of: 'of',
  sevenDays: '7 days',

  // Shifts Page
  manageAndScheduleShifts: 'Manage and schedule shifts',
  noShiftsScheduledForDay: 'No shifts scheduled for this day',
  noShiftsScheduled: 'No shifts scheduled',
  notes: 'Notes',
  additionalNotes: 'Additional notes...',
  assigned: 'assigned',
  availableEmployees: 'Available Employees',
  letAIOptimize: 'Let AI optimize your schedule',
  fairDistribution: 'Fair distribution across all employees',
  minimizeCosts: 'Minimize labor costs',
  ensureFilled: 'Ensure all shifts are filled',
  aiOptimizing: 'AI is optimizing...',
  more: 'more',
  day: 'Day',
  week: 'Week',
  month: 'Month',
  year: 'Year',
  list: 'List',
  partiallyFilled: 'Partially Filled',
  inProgress: 'In Progress',
  completed: 'Completed',
  cancelled: 'Cancelled',

  // Employees
  employeeList: 'Employee List',
  addNewEmployee: 'Add New Employee',
  searchEmployees: 'Search employees...',
  role: 'Role',
  certifications: 'Certifications',
  skills: 'Skills',
  hourlyRate: 'Hourly Rate',
  maxHours: 'Max Hours/Week',
  active: 'Active',
  inactive: 'Inactive',
  manageYourTeamMembers: 'Manage your team members',
  noEmployeesFound: 'No employees found',
  addYourFirstEmployee: 'Add your first employee',
  employeeHeader: 'Employee',
  contact: 'Contact',
  editEmployee: 'Edit Employee',
  failedToSaveEmployee: 'Failed to save employee',
  deactivateEmployeeConfirm: 'Are you sure you want to deactivate this employee?',

  // Shifts
  shiftList: 'Shift List',
  createNewShift: 'Create New Shift',
  shiftTitle: 'Shift Title',
  startTime: 'Start Time',
  endTime: 'End Time',
  requiredEmployees: 'Required Employees',
  assignedEmployees: 'Assigned Employees',
  assign: 'Assign',
  unassign: 'Unassign',
  status: 'Status',
  open: 'Open',
  filled: 'Filled',

  // Time Tracking
  clockIn: 'Clock In',
  clockOut: 'Clock Out',
  timeTracking: 'Time Tracking',

  // Organizations
  organization: 'Organization',
  createOrganization: 'Create Organization',
  organizationName: 'Organization Name',
  subdomain: 'Subdomain',
  industry: 'Industry',
  timezone: 'Timezone',
  country: 'Country',
  language: 'Language',
  branding: 'Branding',
  primaryColor: 'Primary Color',
  secondaryColor: 'Secondary Color',
  logo: 'Logo',

  // Plans
  subscription: 'Subscription',
  currentPlan: 'Current Plan',
  upgradePlan: 'Upgrade Plan',
  free: 'Free',
  pro: 'Professional',
  enterprise: 'Enterprise',
  perMonth: '/month',
  features: 'Features',
  subscriptionManagePlanAndBilling: 'Manage your plan and billing',
  subscriptionManageInStripe: 'Manage in Stripe',
  subscriptionStripeNotConfigured: 'Stripe is not configured. We will simulate the active subscription.',
  subscriptionActivatedSuccessfully: 'Subscription activated successfully!',
  subscriptionErrorProcessing: 'Error processing',
  subscriptionErrorOpeningPortal: 'Error opening portal',
  subscriptionPlanUpgraded: 'Plan upgraded successfully.',
  subscriptionPlanDowngraded: 'Plan downgraded successfully.',
  subscriptionProratedAmount: 'Prorated amount',
  subscriptionErrorChangingPlan: 'Error changing plan',
  subscriptionCancelledImmediately: 'Subscription cancelled immediately. Premium feature access has been disabled.',
  subscriptionEndOfPeriod: 'end of period',
  subscriptionScheduledForCancellation: 'Subscription scheduled for cancellation on {endDate}. Your access will continue until then.',
  subscriptionErrorCancelling: 'Error cancelling subscription',
  subscriptionStripeNotConfiguredTitle: 'Stripe not configured',
  subscriptionStripeNotConfiguredDescription: 'Payments are in simulated mode. Configure Stripe API keys in',
  subscriptionIntegrations: 'Integrations',
  subscriptionToActivateRealPayments: 'to activate real payments.',
  subscriptionCurrentPlan: 'Current Plan',
  subscriptionCancellingNotice: 'Your subscription will be cancelled at the end of the current period. Access will continue until then.',
  subscriptionPerEmployee: 'employee',
  subscriptionPerMonth: 'month',
  subscriptionEmployees: 'employees',
  subscriptionShiftsPerMonth: 'shifts/month',
  subscriptionPlanComparison: 'Plan Comparison',
  subscriptionFeature: 'Feature',
  subscriptionAdmins: 'Administrators',
  subscriptionAnalytics: 'Analytics',
  subscriptionBasic: 'Basic',
  subscriptionAdvanced: 'Advanced',
  subscriptionComplete: 'Complete',
  subscriptionWhiteLabel: 'White-label',
  subscriptionSupport: 'Support',
  subscriptionSupportEmail: 'Email',
  subscriptionSupportPriority: 'Priority',
  subscriptionSupport247: '24/7',
  subscriptionSupportDedicated: 'Dedicated',
  subscriptionReadyForProduction: 'Ready for AWS + Cloudflare',
  subscriptionProductionReadyDescription: 'This subscription system is production-ready. Configure your real Stripe keys after deployment to process payments. Stripe webhooks should point to',
  subscriptionConfirmPlanChange: 'Confirm plan change',
  subscriptionPlanUpgrade: 'Plan Upgrade',
  subscriptionPlanDowngrade: 'Plan Downgrade',
  subscriptionPlanChange: 'Plan Change',
  subscriptionCurrentPlanLabel: 'Current plan',
  subscriptionNewPlan: 'New plan',
  subscriptionRemainingDays: 'Remaining days in current period',
  subscriptionDays: 'days',
  subscriptionProratedCharge: 'Prorated charge',
  subscriptionProratedCredit: 'Prorated credit',
  subscriptionProratedChargeDescription: 'You will be charged this additional amount for the remaining days of the current period. The new plan will be applied immediately.',
  subscriptionProratedCreditDescription: 'You will receive this credit for the remaining days of the current period. The new plan will be applied immediately.',
  subscriptionChangingFrom: 'Changing from',
  subscriptionTo: 'to',
  subscriptionCalculatingProration: 'Calculating proration...',
  subscriptionProcessing: 'Processing...',
  subscriptionConfirmUpgrade: 'Confirm Upgrade',
  subscriptionConfirmDowngrade: 'Confirm Downgrade',
  subscriptionConfirmChange: 'Confirm Change',
  subscriptionCancelSubscription: 'Cancel Subscription',
  subscriptionHowToCancel: 'How would you like to cancel your subscription?',
  subscriptionCancelAtPeriodEnd: 'At end of period',
  subscriptionCancelAtPeriodEndDescription: 'Your access to all premium features will continue until the end of the current period. This is the recommended option.',
  subscriptionCancelImmediately: 'Immediately',
  subscriptionCancelImmediatelyDescription: 'Premium feature access will be disabled immediately. No refunds will be issued.',
  subscriptionKeepSubscription: 'Keep Subscription',
  subscriptionConfirmCancellation: 'Confirm Cancellation',
  subscriptionUpgradePlan: 'Upgrade Plan',
  subscriptionDowngradePlan: 'Downgrade Plan',
  subscriptionChangePlan: 'Change Plan',
  subscriptionSubscribe: 'Subscribe',
  subscriptionPopular: 'Popular',
  subscriptionYourPlan: 'Your Plan',
  subscriptionStatusActive: 'Active',
  subscriptionStatusTrialing: 'Trialing',
  subscriptionStatusIncomplete: 'Incomplete',
  subscriptionStatusIncompleteexpired: 'Incomplete Expired',
  subscriptionStatusPastDue: 'Past Due',
  subscriptionStatusCancelling: 'Cancelling',
  subscriptionStatusCancelled: 'Cancelled',
  subscriptionStatusCanceled: 'Canceled',
  subscriptionStatusUnpaid: 'Unpaid',
  subscriptionStatusNone: 'No Subscription',
  subscriptionIncompleteNotice: 'Payment incomplete. Please complete your payment to activate the subscription.',
  subscriptionPastDueNotice: 'Payment is past due. Please update your payment method to continue service.',

  // CRM
  contacts: 'Contacts',
  deals: 'Deals',
  pipeline: 'Pipeline',
  newContact: 'New Contact',
  newDeal: 'New Deal',
  dragToMove: 'Drag deals between stages to update their status',
  prospecting: 'Prospecting',
  qualification: 'Qualification',
  proposal: 'Proposal',
  negotiation: 'Negotiation',
  won: 'Won',
  lost: 'Lost',
  probability: 'Probability',
  activities: 'Activities',
  tasks: 'Tasks',
  leadScoring: 'Lead Scoring',
  campaigns: 'Campaigns',
  territories: 'Territories',
  teams: 'Teams',
  forecast: 'Forecast',

  // ERP
  expenses: 'Expenses',
  invoices: 'Invoices',
  payroll: 'Payroll',
  budgets: 'Budgets',
  laborCost: 'Labor Cost',
  profitLoss: 'Profit & Loss',
  inventory: 'Inventory',
  suppliers: 'Suppliers',
  purchaseOrders: 'Purchase Orders',
  costCenters: 'Cost Centers',
  projections: 'Projections',

  // Reports
  productivity: 'Productivity',
  trends: 'Trends',
  generateReport: 'Generate Report',
  downloadCSV: 'Download CSV',
  period: 'Period',
  daily: 'Daily',
  weekly: 'Weekly',
  monthly: 'Monthly',
  quarterly: 'Quarterly',
  yearly: 'Yearly',

  // Common
  save: 'Save',
  cancel: 'Cancel',
  delete: 'Delete',
  copy: 'Copy',
  copiedToClipboard: 'Copied to clipboard',
  edit: 'Edit',
  view: 'View',
  search: 'Search',
  filter: 'Filter',
  loading: 'Loading...',
  error: 'Error',
  success: 'Success',
  noData: 'No data available',
  confirm: 'Confirm',
  actions: 'Actions',
  add: 'Add',
  remove: 'Remove',
  update: 'Update',
  create: 'Create',
  export: 'Export',
  import: 'Import',
  download: 'Download',
  upload: 'Upload',
  selectLanguage: 'Select Language',
  liveUpdates: 'Live',
  disconnected: 'Disconnected',
  realtimeActivity: 'Real-time Activity',
  all: 'All',
  today: 'Today',
  thisWeek: 'This Week',
  thisMonth: 'This Month',
  custom: 'Custom',
  from: 'From',
  to: 'To',
  apply: 'Apply',
  reset: 'Reset',
  close: 'Close',
  back: 'Back',
  next: 'Next',
  previous: 'Previous',
  yes: 'Yes',
  no: 'No',
  or: 'or',
  and: 'and',
  total: 'Total',
  average: 'Average',
  min: 'Min',
  max: 'Max',

  // Mobile specific
  profile: 'Profile',
  changePassword: 'Change Password',
  notificationSettings: 'Notification Settings',
  pushNotifications: 'Push Notifications',
  emailNotifications: 'Email Notifications',
  shiftReminders: 'Shift Reminders',
  availability: 'Availability',
  helpSupport: 'Help & Support',
  termsPrivacy: 'Terms & Privacy',
  version: 'Version',
  memberSince: 'Member Since',
  totalShifts: 'Total Shifts',
  hoursWorked: 'Hours Worked',
  attendanceRate: 'Attendance Rate',

  // Admin Panel
  superAdminPanel: 'Super Admin Panel',
  systemWideManagement: 'System-wide management and settings',
  overview: 'Overview',
  organizations: 'Organizations',
  aiSettings: 'AI Settings',
  allOrganizations: 'All Organizations',
  totalUsers: 'Total Users',
  monthlyRecurringRevenue: 'MRR',
  organizationDetails: 'Organization Details',
  subscriptionPlan: 'Subscription Plan',
  organizationInformation: 'Organization Information',
  created: 'Created',
  supportEmail: 'Support Email',
  supportPhone: 'Support Phone',
  monthlyCost: 'Monthly Cost',
  billingPeriod: 'Billing Period',
  domainConfiguration: 'Domain Configuration',
  domainType: 'Domain Type',
  customDomain: 'Custom Domain',
  fullUrl: 'Full URL',
  brandColors: 'Brand Colors',
  primary: 'Primary',
  secondary: 'Secondary',
  aiConfiguration: 'AI Configuration',
  aiProvider: 'AI Provider',
  aiModel: 'AI Model',
  currentConfiguration: 'Current Configuration',
  configureAiModel: 'Configure the AI model used for auto-assignment',
  thisModelWillBeUsed:
    'This model will be used for AI auto-assignment across all Pro and Enterprise organizations.',
  plan: 'Plan',

  // Shifts Page (extra)
  balanced: 'Balanced',
  costOptimized: 'Cost Optimized',
  coverageOptimized: 'Coverage Optimized',
  noOpenShiftsToAssign: 'No open shifts to assign',
  aiAssignmentFailed: 'AI assignment failed',
  failedToCreateShift: 'Failed to create shift',
  failedToAssignEmployee: 'Failed to assign employee',

  // Time Tracking Page
  trackYourWorkHours: 'Track your work hours',
  currentlyWorking: 'Currently Working',
  startedAt: 'Started at',
  locationTracked: 'Location tracked',
  readyToStart: 'Ready to start?',
  selectShiftToClockIn: 'Select a shift to clock in',
  noShiftsScheduledToday: 'No shifts scheduled for today',
  recentTimeEntries: 'Recent Time Entries',
  noTimeEntriesYet: 'No time entries yet',
  hrs: 'hrs',
  failedToClockIn: 'Failed to clock in',
  failedToClockOut: 'Failed to clock out',

  // Multi-location Page
  multiLocationTitle: 'Multi-Location',
  multiLocationSubtitle: 'Manage your work centers and locations',
  addLocation: 'New Location',
  filterByLocation: 'Filter by Location',
  noAssignedLocations: 'You are not assigned to any location',
  showingShiftsFrom: 'Showing shifts from:',
  allLocations: 'All locations',
  locationsCountSuffix: 'location(s)',
  orgAllLocations: 'All Organization Locations',
  availableLocations: 'Available Locations',
  noLocationsConfigured: 'No locations configured',
  createFirstLocation: 'Create first location',
  assignedBadge: 'Assigned',
  assignedEmployeesCountLabel: 'assigned employees',
  unassignMe: 'Unassign me',
  assignMe: 'Assign me',
  editLocationTitle: 'Edit Location',
  newLocationTitle: 'New Location',
  locationCodeLabel: 'Code (e.g.: A-253, HL-851)',
  locationCodePlaceholder: 'A-253',
  locationNameLabel: 'Name',
  locationNamePlaceholder: 'Ambulance 253',
  locationTypeLabel: 'Type',
  locationAddressOptionalLabel: 'Address (optional)',
  locationAddressPlaceholder: 'Main Street 123',
  locationType_general: 'General',
  locationType_ambulance: 'Ambulance',
  locationType_helicopter: 'Helicopter',
  locationType_hospital: 'Hospital',
  locationType_office: 'Office',
  locationType_warehouse: 'Warehouse',
  locationType_store: 'Store',
  locationCreated: 'Location created successfully',
  locationCreateError: 'Error creating location',
  locationUpdated: 'Location updated',
  locationUpdateError: 'Error updating location',
  locationDeleted: 'Location deleted',
  locationDeleteError: 'Error deleting location',
  locationDeleteConfirm: 'Delete this location?',
  assignedToLocation: 'Assigned to location',
  unassignedFromLocation: 'Unassigned from location',

  // Shift Swap Page
  shiftSwapTitle: 'Shift Swap',
  shiftSwapSubtitle: 'Request swaps and publish your availability',
  postAvailability: 'Post Availability',
  requestSwap: 'Request Swap',
  urgentCoveragesTitle: 'Urgent Coverages',
  noLocation: 'No location',
  takeShift: 'Take Shift',
  swapRequestsTab: 'Swap Requests',
  myAvailabilityTab: 'My Availability',
  noActiveSwapRequests: 'No active swap requests',
  createFirstSwapRequest: 'Create first request',
  requestedBy: 'Requested by',
  userFallback: 'User',
  statusPending: 'Pending',
  statusAccepted: 'Accepted',
  statusRejected: 'Rejected',
  statusActive: 'Active',
  available: 'Available',
  preferenceLabel: 'Preference',
  preferenceMorning: 'Morning',
  preferenceAfternoon: 'Afternoon',
  preferenceNight: 'Night',
  preferenceAny: 'Any',
  timePreference: 'Time preference',
  preferenceAnyWithRange: 'Any time',
  preferenceMorningWithRange: 'Morning (6:00 - 14:00)',
  preferenceAfternoonWithRange: 'Afternoon (14:00 - 22:00)',
  preferenceNightWithRange: 'Night (22:00 - 6:00)',
  noAvailabilityPublished: 'You have not published any availability',
  publishAvailabilityHint: 'Publish when you are available to receive swap offers',
  swapReasonDefault: 'Shift swap request',
  swapRequestCreated: 'Swap request created',
  swapRequestCreateError: 'Error creating swap request',
  availabilityPosted: 'Availability posted',
  swapAccepted: 'Swap accepted',
  urgentShiftTaken: 'Shift successfully assigned!',
  urgentShiftError: 'Error taking shift',
  swapRequestCancelled: 'Swap request cancelled',
  selectShiftForSwap: 'Select one of your upcoming shifts to request a swap:',
  swapInfoPlaceholder: 'Shifts available for swap will appear here.',
  swapInfoHint: 'Go to your shift calendar to select one.',

  // Chat Page
  channels: 'Channels',
  searchPlaceholder: 'Search...',
  noChannels: 'No channels',
  createFirstChannel: 'Create the first one',
  membersLabel: 'members',
  noMessagesYet: 'No messages yet',
  beFirstToWrite: 'Be the first to write!',
  messagePlaceholder: 'Message in #{channel}',
  selectChannelPrompt: 'Select a channel',
  selectChannelHint: 'or create a new one to get started',
  editedLabel: '(edited)',
  messageDeleted: 'Message deleted',
  createChannelTitle: 'Create Channel',
  channelNameLabel: 'Channel Name *',
  channelNamePlaceholder: 'general',
  channelDescriptionLabel: 'Description',
  channelDescriptionPlaceholder: 'What is this channel about?',
  channelTypeLabel: 'Channel Type',
  channelTypePublic: 'Public',
  channelTypePrivate: 'Private',
  createChannelAction: 'Create Channel',

  // Layout / Navigation sections & mobile nav
  mainSection: 'Main',
  toolsSection: 'Tools',
  adminSection: 'Administration',
  markAllRead: 'Mark all as read',
  noNotifications: 'No notifications',
  mobileHome: 'Home',
  mobileShifts: 'Shifts',
  mobileClock: 'Clock',
  mobileTeam: 'Team',
  mobileMore: 'More',

  // Chat Page (super admin org selector)
  allOrganizationsOption: 'All organizations',
  selectOrgForChat: 'Select an organization to view its chat channels.',
  selectOrgForChatTitle: 'Select an organization',
  selectOrgForChatDescription:
    'As a super admin, choose an organization from the sidebar to view and manage its internal chat channels.',

  // Leave Page
  leaveTitle: 'Leave & Absences',
  leaveSubtitle: 'Manage your vacation days and time-off requests',
  leaveNewRequest: 'New Request',
  leaveMyBalanceTab: 'My Balance',
  leaveMyRequestsTab: 'My Requests',
  leaveYearLabel: 'Year',
  leaveTotalAnnual: 'Total annual',
  leaveUsed: 'Used',
  leavePending: 'Pending',
  leaveAvailable: 'Available',
  leaveDaysSuffix: 'days',
  leaveNoPolicies: 'No leave policies configured',
  leaveNoRequestsTitle: 'No requests',
  leaveNoRequestsSubtitle: "You don't have any vacation or leave requests",
  leaveCreateFirstRequest: 'Create first request',
  leaveRejectionReasonLabel: 'Reason',
  leaveRequestCreated: 'Leave request created successfully',
  leaveSelectDatesError: 'Please select start and end dates',
  leaveTypeLabel: 'Leave Type',
  leaveAvailableDaysLabel: 'Available days:',
  leaveStartDate: 'Start Date',
  leaveEndDate: 'End Date',
  leaveHalfDay: 'Half day',
  leaveReasonOptional: 'Reason (optional)',
  leaveReasonPlaceholder: 'Describe the reason for your request...',
  leaveSubmitRequest: 'Submit Request',

  leaveTeamRequestsTab: 'Team Requests',
  leaveTeamNoRequestsTitle: 'No team requests',
  leaveTeamNoRequestsSubtitle: 'There are no pending leave requests for your team.',
  leaveApprove: 'Approve',
  leaveReject: 'Reject',
  leaveRequestApproved: 'Leave request approved',
  leaveRequestRejected: 'Leave request rejected',
  leaveApproveError: 'Error approving leave request',
  leaveRejectError: 'Error rejecting leave request',
  leaveRejectPrompt: 'Optional: Add a reason for rejection',
  leaveCurrentApproverLabel: 'Currently with:',
  roleManager: 'Manager',
  roleOrgAdmin: 'Organization admin',
  roleSuperAdmin: 'Super admin',

  // Gamification Page
  gamificationTabProfile: 'My Profile',
  gamificationTabChallenges: 'Challenges',
  gamificationTabBadges: 'Badges',
  gamificationTabLeaderboard: 'Leaderboard',
  gamificationTabRewards: 'Rewards',
  gamificationOptInTitle: 'Join the Rewards Program!',
  gamificationOptInSubtitle:
    'Earn points for punctuality, helping teammates and redeem them for amazing rewards.',
  gamificationOptInComplianceTitle: 'GDPR/HIPAA Compliance',
  gamificationOptInPoint1: 'Only work performance data is recorded',
  gamificationOptInPoint2: 'You can opt out and delete your data at any time',
  gamificationOptInPoint3: 'Participation in the leaderboard is optional',
  gamificationOptInJoining: 'Joining...',
  gamificationOptInCTA: 'Join Now',
  gamificationHeaderTitle: 'Rewards Program',
  gamificationLevelLabel: 'Level {{level}}',
  gamificationCurrentStreakLabel: '{{days}}-day streak',
  gamificationTotalPointsLabel: 'Total Points',
  gamificationCurrentPeriodLabel: 'This Period',
  gamificationCurrentStreakTitle: 'Current Streak',
  gamificationConsecutiveDaysLabel: 'consecutive days',
  gamificationBestStreakLabel: 'Best: {{days}} days',
  gamificationOnTimeLabel: 'On-time Arrivals',
  gamificationThisPeriodLabel: 'this period',
  gamificationBadgesOfTotalLabel: 'of {{total}} total',
  gamificationChallengesTitle: "This Week's Challenges",
  gamificationChallengesCompletedLabel: '{{completed}}/{{total}} completed',
  gamificationClaimRewardButton: 'Claim Reward',
  gamificationRewardAlreadyClaimed: 'Reward claimed',
  gamificationNoChallengesMessage: 'No active challenges this week',
  gamificationEarnedBadgesTitle: 'Earned Badges',
  gamificationAvailableBadgesTitle: 'Available',
  gamificationAnonymousLabel: 'Anonymous',
  gamificationOnTimeCountLabel: '{{count}} on-time arrivals',
  gamificationPointsSuffix: 'points',
  gamificationNoLeaderboardMessage: 'No participants yet. Be the first!',
  gamificationRewardCostLabel: '{{points}} pts',
  gamificationRedeemButton: 'Redeem',
  gamificationNoRewardsMessage: 'No rewards available. Ask your admin.',
  gamificationRewardRedeemed: 'Reward redeemed!',
  gamificationRewardRedeemError: 'Error redeeming reward',
  
  // Hours & Documents Page
  hoursDocumentsTitle: 'Hours & Documents',
  hoursDocumentsSubtitle: 'Track worked hours and document management',
  exportPDF: 'Export PDF',
  pdfDownloadedSuccessfully: 'PDF downloaded successfully',
  documentReadyToPrint: 'Document ready to print',
  exportError: 'Export error',
  selectFile: 'Please select a file',
  documentUploadedSuccessfully: 'Document uploaded successfully',
  documentUploadError: 'Error uploading document',
  deleteDocumentConfirm: 'Delete this document?',
  documentDeleted: 'Document deleted',
  documentDeleteError: 'Error deleting document',
  hoursSummaryTab: 'Hours Summary',
  totalHoursLabel: 'Total Hours',
  teamAverage: 'Team average',
  regularHours: 'Regular Hours',
  overtimeHours: 'Overtime Hours',
  multiplier: 'Multiplier',
  nightHours: 'Night Hours',
  detailedBreakdown: 'Detailed Breakdown',
  saturdays: 'Saturdays',
  sundays: 'Sundays',
  holidays: 'Holidays',
  totalEquivalent: 'Total Equivalent',
  shiftsCompleted: 'Shifts Completed',
  daysWorked: 'Days Worked',
  dailyAverage: 'Daily Average',
  uploadDocument: 'Upload Document',
  documentType: 'Document Type',
  descriptionOptional: 'Description (optional)',
  documentDescriptionPlaceholder: 'E.g.: Sick leave January 2026',
  file: 'File',
  myDocuments: 'My Documents',
  noDocumentsUploaded: 'You have no uploaded documents',
  uploaded: 'Uploaded',
  approved: 'Approved',
  rejected: 'Rejected',
  documentTypeSickLeave: 'Sick Leave',
  documentTypeCertification: 'Certification',
  documentTypeTraining: 'Training',
  documentTypeContract: 'Contract',
  documentTypeOther: 'Other',
  monthJanuary: 'January',
  monthFebruary: 'February',
  monthMarch: 'March',
  monthApril: 'April',
  monthMay: 'May',
  monthJune: 'June',
  monthJuly: 'July',
  monthAugust: 'August',
  monthSeptember: 'September',
  monthOctober: 'October',
  monthNovember: 'November',
  monthDecember: 'December',

  // Digital Signatures Page
  digitalSignaturesTitle: 'Digital Signatures',
  digitalSignaturesSubtitle: 'Document and electronic signature management with legal validity',
  newDocument: 'New Document',
  youHavePendingDocuments: 'You have {count} document(s) pending signature',
  clickPendingToSign: 'Click on "Pending" to view and sign documents',
  documentsTab: 'Documents',
  pendingTab: 'Pending',
  myCertificates: 'My Certificates',
  standardsTab: 'Standards',
  partiallySigned: 'Partially Signed',
  expired: 'Expired',
  draft: 'Draft',
  noDocuments: 'No documents',
  createNewDocumentToSend: 'Create a new document to send for signature',
  noDocumentsAssigned: 'You have no assigned documents',
  expires: 'Expires',
  signNow: 'Sign Now',
  allSigned: 'All signed!',
  noPendingDocuments: 'You have no documents pending signature',
  myDigitalCertificates: 'My Digital Certificates',
  addCertificate: 'Add Certificate',
  noCertificates: 'No certificates',
  addDigitalCertificate: 'Add a digital certificate for advanced and qualified signatures',
  supportedCertificates: 'Supported certificates:',
  x509Pkcs12: 'X.509 / PKCS#12',
  electronicIdSpain: 'Electronic ID (Spain)',
  qualifiedEidas: 'Qualified eIDAS certificates',
  nationalCa: 'National CA certificates',
  qualified: 'Qualified',
  validUntil: 'Valid until',
  certificateRegistered: 'Certificate registered successfully',
  rostafySupportsSignatures: 'Rostafy supports electronic signatures with legal validity in multiple jurisdictions',
  availableSignatureTypes: 'Available signature types:',
  requiresCertificate: 'Requires certificate',
  qualifiedCertificate: 'Qualified certificate',
  maximum: 'Maximum',
  high: 'High',
  valid: 'Valid',
  createDocumentForSignature: 'Create Document for Signature',
  title: 'Title',
  documentTitlePlaceholder: 'E.g.: Employment Contract - John Doe',
  documentContent: 'Document Content',
  documentContentPlaceholder: 'Paste here the HTML or text content of the document...',
  legalRegion: 'Legal Region',
  signatureType: 'Signature Type',
  simplePinEmail: 'Simple (PIN/Email)',
  advancedCertificate: 'Advanced (Certificate)',
  qualifiedQualified: 'Qualified (Qualified Certificate)',
  signers: 'Signers',
  addSigner: 'Add signer',
  name: 'Name',
  signer: 'Signer',
  approver: 'Approver',
  witness: 'Witness',
  daysToSign: 'Days to sign',
  createDocument: 'Create Document',
  documentCreated: 'Document created successfully',
  errorCreatingDocument: 'Error creating document',
  signDocument: 'Sign Document',
  simple: 'Simple',
  pinVerification: 'PIN verification',
  advanced: 'Advanced',
  withDigitalCertificate: 'With digital certificate',
  qualifiedQes: 'Qualified (QES)',
  maximumLegalValidity: 'Maximum legal validity',
  selectCertificate: 'Select certificate...',
  certificate: 'Certificate',
  signatureMethod: 'Signature Method',
  typeName: 'Type name',
  clickToSign: 'Click to sign',
  yourFullName: 'Your Full Name',
  typeYourFullName: 'Type your full name',
  confirmationPin: 'Confirmation PIN',
  enterPinDigits: 'Enter a 4-6 digit PIN',
  legalNotice: 'By signing, I confirm that I have read and accept the content of the document. This signature has legal validity according to applicable regulations.',
  signDocumentButton: 'Sign Document',
  documentSigned: 'Document signed successfully',
  errorSigning: 'Error signing',
  registerCertificate: 'Register Certificate',
  type: 'Type',
  issuer: 'Issuer',
  issuerPlaceholder: 'E.g.: FNMT, DigiCert, etc.',
  serialNumber: 'Serial Number',
  serialNumberPlaceholder: 'Certificate serial number',
  validFrom: 'Valid from',
  validUntilLabel: 'Valid until',
  certificateDataBase64: 'Certificate Data (Base64)',
  certificateDataPlaceholder: 'Paste the certificate in Base64 format here...',
  errorRegisteringCertificate: 'Error registering certificate',
  send: 'Send',
  documentSent: 'Document sent for signature',
  errorSending: 'Error sending',
  signed: 'signed',
  region: 'Region',

  // Reports Page
  reportsSubtitle: 'Generate and export reports',
  reportsPeriodTitle: 'Report Period',
  reportsShiftsDescription: 'List of shifts with assignments',
  reportsHoursDescription: 'Breakdown of hours per employee',
  reportsAttendanceDescription: 'Attendance rate per employee',
  reportsSwapsDescription: 'Shift swap requests',
  reportsComplianceDescription: 'Rule and policy violations',
  reportsPayrollDescription: 'Summary of calculated payments',
  reportsProductivityDescription: 'Performance metrics per employee',
  reportsLaborCostDescription: 'Daily and weekly labor cost analysis',
  reportsTrendsDescription: 'Historical analysis for recent months',
  reportsHourlyRateLabel: '€/hour',
  reportsOvertimeMultiplierLabel: 'Overtime x',
  reportsTrendsMonthsLabel: 'Months to analyze',
  reportsLast3Months: 'Last 3 months',
  reportsLast6Months: 'Last 6 months',
  reportsLast12Months: 'Last year',
  reportsLast24Months: 'Last 2 years',
  reportsDownloaded: 'Report downloaded',
  reportsGenerateError: 'Error generating report',
  reportsReportLabel: 'Report',
  reportsGeneratedAt: 'Generated',
  reportsDownloadJsonButton: 'Download JSON',
  reportsLimitedRows: 'Showing 20 of {total} records. Download the JSON to see all.',

  // Payroll Page
  payrollTitle: 'Payroll Management',
  payrollSubtitle: 'Calculate and manage your employees payroll',
  payrollExportSuccess: 'Export completed',
  payrollExportError: 'Error exporting',
  payrollPeriodApproved: 'Period approved',
  payrollApproveError: 'Error approving period',
  payrollCurrencyLabel: 'Currency',
  payrollPayPeriodLabel: 'Pay Period',
  payrollOvertimeMultiplierSummary: 'Overtime Mult.',
  payrollNightMultiplierSummary: 'Night Mult.',
  payrollPeriodsTitle: 'Payroll Periods',
  payrollNoPeriodsTitle: 'No periods',
  payrollNoPeriodsSubtitle: 'Create your first payroll period to get started',
  payrollCreateFirstPeriod: 'Create Period',
  payrollTotalGross: 'Total Gross',
  payrollTotalNet: 'Total Net',
  payrollViewDetails: 'View Details',
  payrollApprove: 'Approve',
  payrollExportCsv: 'Export CSV',
  payrollEmployeesLabel: 'employees',
  payrollNoEntriesTitle: 'No calculated entries',
  payrollNoEntriesSubtitle: 'Run payroll calculation to see details',
  payrollHoursRegular: 'Regular',
  payrollHoursOvertime: 'Overtime',
  payrollHoursNight: 'Night',
  payrollHoursWeekend: 'Weekend',
  payrollHoursHoliday: 'Holiday',
  payrollGrossLabel: 'Gross',
  payrollIncomeTaxLabel: 'Income Tax',
  payrollSocialSecurityLabel: 'Social Security',
  payrollSelectDatesError: 'Please select dates',
  payrollCreatePeriodError: 'Error creating period',
  payrollNewPeriod: 'New Payroll Period',
  payrollPeriodNameOptional: 'Name (optional)',
  payrollPeriodNamePlaceholder: 'January 2026 Payroll',
  payrollStartDateLabel: 'Start Date *',
  payrollEndDateLabel: 'End Date *',
  payrollCreatePeriod: 'Create Period',
  payrollSettingsTitle: 'Payroll Settings',
  payrollOvertimeMultiplierLabel: 'Overtime',
  payrollNightMultiplierLabel: 'Night',
  payrollWeekendMultiplierLabel: 'Weekend',
  payrollHolidayMultiplierLabel: 'Holiday',
  payrollDefaultDeductionsTitle: 'Default Deductions',

  // AI Auto-Assign Page
  aiAutoAssignTitle: 'AI Auto-Assignment',
  aiAutoAssignSubtitle: 'Automatically generate schedules respecting your organization rules',
  aiAutoAssignTabGenerate: 'Generate Schedule',
  aiAutoAssignTabRules: 'Organization Rules',
  aiAutoAssignTabTemplates: 'Shift Templates',
  aiAutoAssignTabHistory: 'History',
  aiAutoAssignStatRunsLast30Days: 'Runs (30d)',
  aiAutoAssignStatAssignments: 'Assignments',
  aiAutoAssignSelectPeriod: 'Select Period',
  aiAutoAssignModePreview: 'Preview',
  aiAutoAssignModePreviewDesc: 'View without saving',
  aiAutoAssignModeDraft: 'Draft',
  aiAutoAssignModeDraftDesc: 'Save as draft',
  aiAutoAssignModeApply: 'Apply',
  aiAutoAssignModeApplyDesc: 'Save and activate',
  aiAutoAssignGenerating: 'Generating...',
  aiAutoAssignGenerateButton: 'Generate Schedule',
  aiAutoAssignResultTitleSuccess: 'Schedule Generated',
  aiAutoAssignModeAppliedBadge: 'Applied',
  aiAutoAssignModeDraftBadge: 'Draft',
  aiAutoAssignModePreviewBadge: 'Preview',
  aiAutoAssignPeriodLabel: 'Period',
  aiAutoAssignSummaryShiftsGenerated: 'Shifts Generated',
  aiAutoAssignSummaryAssignments: 'Assignments',
  aiAutoAssignSummaryUnassigned: 'Unassigned',
  aiAutoAssignSummaryWarnings: 'Warnings',
  aiAutoAssignAssignmentsTitle: 'Assignments',
  aiAutoAssignScoreLabel: 'Score',
  aiAutoAssignWarningsTitle: 'Warnings',
  aiAutoAssignUnassignedTitle: 'Unassigned Positions',
  aiAutoAssignMissingLabel: 'missing',
  aiAutoAssignRulesTitle: 'Your Organization Rules',
  aiAutoAssignEditRulesButton: 'Edit Rules',
  aiAutoAssignRulesInfo: 'These rules are automatically applied when generating schedules. Customize them according to your agreements and internal policies.',
  aiAutoAssignOptionsTitle: 'Options',
  aiAutoAssignActiveLabel: 'Active',
  aiAutoAssignInactiveLabel: 'Inactive',
  aiAutoAssignTemplatesTitle: 'Shift Templates',
  aiAutoAssignNewTemplate: 'New Template',
  aiAutoAssignPositionsLabel: 'positions',
  aiAutoAssignHistoryTitle: 'Execution History',
  aiAutoAssignNoRuns: 'No runs recorded yet',
  aiAutoAssignHistoryShifts: 'shifts',
  aiAutoAssignHistoryAssigned: 'assigned',
  aiAutoAssignHistoryUnassigned: 'unassigned',
  aiAutoAssignRuleMaxHoursWeek: 'Max hours/week',
  aiAutoAssignRuleMaxHoursDay: 'Max hours/day',
  aiAutoAssignRuleMinRestBetweenShifts: 'Minimum rest between shifts',
  aiAutoAssignRuleMaxConsecutiveDays: 'Max consecutive days',
  aiAutoAssignRuleMaxConsecutiveWeekends: 'Max consecutive weekends',
  aiAutoAssignRuleMaxConsecutiveNights: 'Max consecutive night shifts',
  aiAutoAssignRuleOvertimeThreshold: 'Overtime threshold',
  aiAutoAssignRuleRestAfterNightHours: 'Rest after night shift',
  aiAutoAssignBoolOvertimeRequiresApproval: 'Overtime requires approval',
  aiAutoAssignBoolRespectPreferences: 'Respect employee preferences',
  aiAutoAssignBoolBalanceWorkload: 'Balance workload',
  aiAutoAssignBoolRotationWeekends: 'Rotate weekends',
  aiAutoAssignBoolNightShiftLimits: 'Apply night shift limits',
  aiAutoAssignSaveRulesError: 'Error saving rules',
  aiAutoAssignGenerateError: 'Error generating schedule'

  // AI Predictions Page
  ,aiPredictionsTitle: 'AI Predictions',
  aiPredictionsSubtitle: 'Smart analysis with Aria for workforce optimization',
  aiPredictionsRefreshButton: 'Refresh',
  aiPredictionsGdprTitle: 'GDPR/HIPAA Compliance:',
  aiPredictionsGdprText:
    'All predictions use aggregated and anonymized data. No personal health information is collected or stored.',
  aiPredictionsTabDemand: 'Demand Forecast',
  aiPredictionsTabBurnout: 'Burnout Detection',
  aiPredictionsTabChurn: 'Churn Prediction',
  aiPredictionsTabCosts: 'Cost Optimization',
  aiPredictionsTabComprehensive: 'Aria Analysis',
  aiPredictionsAriaAnalysisLabel: 'Aria analysis',
  aiPredictionsEmployeesLabel: 'employees',
  aiPredictionsWeekendBadge: 'Weekend',
  aiPredictionsHourlyBreakdownTitle: 'Hourly Breakdown (Today)',
  aiPredictionsForecastInsightTitle: 'AI Analysis of Forecast',
  aiPredictionsBurnoutTeamHealth: 'Team Health',
  aiPredictionsBurnoutRiskDistribution: 'Risk Distribution',
  aiPredictionsRiskLow: 'Low',
  aiPredictionsRiskModerate: 'Moderate',
  aiPredictionsRiskHigh: 'High',
  aiPredictionsRiskCritical: 'Critical',
  aiPredictionsPrivacyNoticeTitle: 'Privacy Notice:',
  aiPredictionsChurnRetentionHealth: 'Retention Health',
  aiPredictionsChurnExitRisk: 'Exit Risk',
  aiPredictionsChurnAtRiskLabel: '{{percent}}% of the team',
  aiPredictionsChurnTeamAnalyzed: 'Team Analyzed',
  aiPredictionsChurnOfTeamLabel: 'of {{count}} employees',
  aiPredictionsChurnRiskDistribution: 'Churn Risk Distribution',
  aiPredictionsChurnNoticeTitle: 'AI Prediction:',
  aiPredictionsChurnNoticeText:
    'Churn prediction is based on work patterns (hours, punctuality, cancellations) – not personal data. Employees at high risk may benefit from proactive conversations about career development.',
  aiPredictionsCostsTotalLabor: 'Total Labor Cost',
  aiPredictionsLastNDays: 'last {{days}} days',
  aiPredictionsCostsOvertime: 'Overtime Hours',
  aiPredictionsCostsOvertimeCost: '${{value}} cost',
  aiPredictionsCostsSavingsPotential: 'Savings Potential',
  aiPredictionsCostsSavingsHint: 'possible savings',
  aiPredictionsCostsAvgHourly: 'Average Hourly Cost',
  aiPredictionsOptimizationSuggestionsTitle: 'Optimization Suggestions',
  aiPredictionsPriorityHigh: 'HIGH PRIORITY',
  aiPredictionsPriorityMedium: 'MEDIUM PRIORITY',
  aiPredictionsPriorityLow: 'LOW PRIORITY',
  aiPredictionsSavingsLabel: 'Save ${{value}}',
  aiPredictionsImpactLabel: 'Impact',
  aiPredictionsCostsInsightTitle: 'Aria Analysis – Cost Optimization',
  aiPredictionsComprehensiveLoading: 'Aria is analyzing your organization...',
  aiPredictionsComprehensiveLoadingHint: 'This may take 15–30 seconds',
  aiPredictionsTeamSizeLabel: 'Team Size',
  aiPredictionsTeamHealthLabel: 'Team Health',
  aiPredictionsBurnoutAtRiskLabel: 'At Risk of Burnout',
  aiPredictionsSavingsPotentialLabel: 'Savings Potential',
  aiPredictionsComprehensiveTitle: 'Aria Comprehensive Analysis',
  aiPredictionsComprehensiveMeta:
    'Industry: {{industry}} | Generated: {{date}}',
  aiPredictionsBadgeGdpr: 'GDPR Compliant',
  aiPredictionsBadgeHipaa: 'HIPAA Compliant',
  aiPredictionsBadgePoweredByAria: 'Powered by Aria',
  aiPredictionsComprehensiveIntroTitle: 'Comprehensive Analysis with Aria',
  aiPredictionsComprehensiveIntroText:
    'Aria will analyze all your organization data to generate personalized strategic recommendations.',
  aiPredictionsComprehensiveButton: 'Generate Analysis with Aria',

  // Settings Page
  settingsSubtitle: 'Customize your organization',
  settingsTabBranding: 'Branding',
  settingsTabSmtp: 'Email (SMTP)',
  settingsTabSms: 'SMS',
  settingsTabDomain: 'Domain',
  settingsTabCalendar: 'Calendar',
  settingsTabSecurity: 'Security',
  settingsNoOrganizationTitle: 'No organization',
  settingsNoOrganizationSubtitle: 'You need to create or join an organization first.',

  // Branding subsection
  settingsBrandingTitle: 'Brand Customization',
  settingsBrandingDescription:
    'Customize your organization colors and information to create a unique brand experience.',
  settingsBrandingColorsTitle: 'Brand Colors',
  settingsAccentColorLabel: 'Accent Color',
  settingsBrandingPreviewTitle: 'Preview',
  settingsBrandingPrimaryButton: 'Primary Button',
  settingsBrandingSecondaryButton: 'Secondary Button',
  settingsBrandingAccentButton: 'Accent',
  settingsBrandingSaved: 'Branding settings saved!',
  saveChanges: 'Save changes',

  // SMTP subsection
  settingsSmtpTitle: 'Email (SMTP) Configuration',
  settingsSmtpDescription:
    'Configure your own SMTP server to send emails to your employees from your domain.',
  settingsSmtpConfigured: 'SMTP configured and active',
  settingsSmtpServerLabel: 'SMTP Server',
  settingsSmtpPortLabel: 'Port',
  settingsSmtpUserLabel: 'User',
  settingsSmtpPasswordLabel: 'Password',
  settingsSmtpFromEmailLabel: 'From Email',
  settingsSmtpFromNameLabel: 'From Name',
  settingsSmtpUseTlsLabel: 'Use TLS/STARTTLS',
  settingsTestConfigurationTitle: 'Test Configuration',
  settingsSendTestButton: 'Send Test',
  settingsSmtpSaved: 'SMTP settings saved!',
  settingsSaveSmtpButton: 'Save SMTP',
  settingsSmtpTestEmailRequired: 'Enter a test email',
  settingsSmtpTestSuccess: 'Test email sent successfully!',
  settingsSmtpTestError: 'Error testing SMTP',
  settingsSmtpErrorSaving: 'Error saving SMTP settings',

  // Generic save error
  settingsSaveError: 'Error saving',

  // SMS subsection
  settingsSmsTitle: 'SMS Configuration',
  settingsSmsDescription: 'Configure your SMS provider to send notifications to your employees.',
  settingsSmsSaved: 'SMS settings saved!',
  settingsSmsDeleted: 'SMS configuration deleted',
  settingsSmsErrorSaving: 'Error saving SMS settings',
  settingsSmsErrorDeleting: 'Error deleting SMS configuration',
  settingsSmsProviderLabel: 'SMS Provider',
  settingsSmsProviderTwilio: 'Twilio',
  settingsSmsProviderTwilioDescription: 'Most popular',
  settingsSmsProviderVonage: 'Vonage (Nexmo)',
  settingsSmsProviderVonageDescription: 'Global coverage',
  settingsSmsProviderMessagebird: 'MessageBird',
  settingsSmsProviderMessagebirdDescription: 'Europe and beyond',
  settingsSmsProviderCustom: 'Custom API',
  settingsSmsProviderCustomDescription: 'Your own provider',
  settingsSmsPhoneLabel: 'Phone Number',
  settingsSmsTwilioHelp: 'Get your credentials at',
  settingsSmsFromLabel: 'Sender (From)',
  settingsSmsCustomUrlLabel: 'API URL',
  settingsSmsCustomMethodLabel: 'Method',
  settingsSmsCustomBodyLabel: 'Body Template (JSON)',
  settingsSmsCustomBodyHint: 'Use {{phone}} and {{message}} as variables',
  settingsSmsCustomAuthLabel: 'Authentication',
  settingsSmsAuthNone: 'No authentication',
  settingsSmsAuthValueLabel: 'Auth value',
  settingsSmsTestPhoneRequired: 'Enter a test phone number',
  settingsSmsTestSuccess: 'Test SMS sent!',
  settingsSmsTestError: 'Error testing SMS',
  settingsSmsDeleteConfirm: 'Delete SMS configuration?',
  settingsSaveSmsButton: 'Save SMS',
  settingsSmsTestConfigTitle: 'Test Configuration',

  // Domain subsection
  settingsDomainTitle: 'Domain Configuration',
  settingsDomainDescription: 'Configure a custom domain for your scheduling platform.',
  settingsDomainSaved: 'Domain settings saved!',
  settingsDomainErrorSaving: 'Error saving domain',
  settingsDomainDnsInstructionsTitle: 'DNS Configuration Instructions',
  settingsDomainCurrentLabel: 'Current domain:',
  settingsDomainTypeLabel: 'Domain Type',
  settingsDomainOptionSubdomainTitle: 'ROSTAFY Subdomain (Free)',
  settingsDomainOptionCustomTitle: 'Your Own Domain (Free)',
  settingsDomainOptionCustomDescription: 'Use a domain you already own',
  settingsDomainOptionManagedTitle: 'ROSTAFY Managed Domain',
  settingsDomainOptionManagedBadge: '+9.99€/month',
  settingsDomainOptionManagedDescription: 'We acquire and configure the domain for you',
  settingsDomainCnameLabel: 'Point your CNAME to:',
  settingsDomainSaveButton: 'Save Configuration',
  settingsDomainVerifyButton: 'Verify DNS',
  settingsDomainVerifyError: 'Error verifying domain',

  // Calendar subsection
  settingsCalendarTitle: 'Calendar Sync',
  settingsCalendarDescription:
    'Sync your shifts with your favorite calendar (Google Calendar, Outlook, Apple Calendar, etc.)',
  settingsCalendarNoFeedTitle: 'No calendar feed configured',
  settingsCalendarNoFeedSubtitle: 'Set up your feed to sync your shifts with any calendar.',
  settingsCalendarSetupButton: 'Set up Calendar Feed',
  settingsCalendarSetupSuccess: 'Calendar feed configured successfully!',
  settingsCalendarFeedConfigured: 'Calendar feed configured and active',
  settingsCalendarUrlLabel: 'Your Calendar URL',
  settingsCalendarCopySuccess: 'URL copied to clipboard',
  settingsCalendarHowToAddTitle: 'How to add to your calendar:',
  settingsCalendarGoogleTitle: '📅 Google Calendar',
  settingsCalendarGoogleStep1: '1. Open Google Calendar',
  settingsCalendarGoogleStep2: '2. Click + next to Other calendars',
  settingsCalendarGoogleStep3: '3. Select From URL',
  settingsCalendarGoogleStep4: '4. Paste the URL above',
  settingsCalendarOutlookTitle: '📧 Microsoft Outlook',
  settingsCalendarOutlookStep1: '1. Open Outlook Calendar',
  settingsCalendarOutlookStep2: '2. Add calendar → Subscribe',
  settingsCalendarOutlookStep3: '3. Paste the URL above',
  settingsCalendarOutlookStep4: '4. Click Import',
  settingsCalendarAppleTitle: '🍎 Apple Calendar',
  settingsCalendarAppleStep1: '1. Open Calendar on Mac/iPhone',
  settingsCalendarAppleStep2: '2. File → New subscription',
  settingsCalendarAppleStep3: '3. Paste the URL above',
  settingsCalendarAppleStep4: '4. Click Subscribe',
  settingsCalendarWebcalTitle: '🔗 WebCal URL',
  settingsCalendarWebcalOpen: 'Open in calendar app',
  settingsCalendarRegenerateTitle: 'Regenerate URL',
  settingsCalendarRegenerateDescription:
    'If you think your URL has been compromised, generate a new one.',
  settingsCalendarRegenerateButton: 'Regenerate',
  settingsCalendarRegenerated: 'Calendar URL regenerated',
  settingsCalendarErrorSetup: 'Error setting up calendar feed',
  settingsCalendarErrorRegenerate: 'Error regenerating calendar URL',

  // Security / 2FA subsection
  settingsSecurityTitle: 'Two-Factor Authentication (2FA)',
  settingsSecurityDescription:
    'Protect your account with two-factor authentication using an authenticator app.',
  settingsSecurity2faEnabled: '2FA Enabled',
  settingsSecurity2faDisabled: '2FA Disabled',
  settingsSecurity2faEnabledText: 'Your account is protected with two-factor authentication',
  settingsSecurity2faDisabledText: 'Enable 2FA to add an additional layer of security',
  settingsSecurityManage2faTitle: 'Manage 2FA',
  settingsSecurityBackupCodesTitleShort: 'Backup Codes',
  settingsSecurityBackupCodesSaved: 'You have backup codes saved',
  settingsSecurityBackupCodesNotSaved: 'You do not have backup codes',
  settingsSecurityRegenerate: 'Regenerate',
  settingsSecurityHowToUseBackupCodesTitle: 'How to use backup codes?',
  settingsSecurityHowToUseBackupCodesText:
    'If you lose access to your authenticator app, you can use one of your 8-character backup codes during login. Each code can only be used once. After using a code, it will be automatically deleted.',
  settingsSecurityDisable2fa: 'Disable 2FA',
  settingsSecuritySetup2fa: 'Setup 2FA',
  settingsSecurityScanQrCode:
    'Scan the QR code with your authenticator app (Google Authenticator, Authy, Microsoft Authenticator, etc.)',
  settingsSecurityManualCodeLabel: 'Or enter this code manually:',
  settingsSecurityEnterCodeLabel: 'Enter the 6-digit code from your authenticator app:',
  settingsSecurityVerifyAndEnable: 'Verify and Enable',
  settingsSecuritySaveNewBackupCodes: 'Save these new backup codes!',
  settingsSecurityBackupCodesOnlyOnceTitle: 'Save these backup codes!',
  settingsSecurityOldCodesInvalid:
    'Previous codes will no longer work. Save these new codes in a safe place. They will only be shown once.',
  settingsSecurityBackupCodesOnlyOnce:
    'These codes will allow you to access your account if you lose access to your authenticator app. They will only be shown once.',
  settingsSecurityBackupCodesTitle: 'Backup Codes',
  settingsSecurityDownload: 'Download',
  settingsSecurityCodesSavedButton: 'I have saved the codes',
  settingsSecurityRegenerateVerifyText:
    'To regenerate backup codes, you need to verify your identity with a code from your authenticator app.',
  settingsSecurityVerificationCodeLabel: 'Verification code (6 digits):',
  settingsSecurityRegenerateCodes: 'Regenerate Codes',
  settingsSecurityWarningTitle: 'Warning',
  settingsSecurityDisableWarningText:
    'Disabling 2FA will reduce your account security. Make sure you have your backup codes saved.',

  settings2faErrorSetup: 'Error setting up 2FA',
  settings2faInvalidCode: 'Invalid code',
  settings2faEnabledSuccess: '2FA enabled successfully',
  settings2faDisabledSuccess: '2FA disabled successfully',
  settings2faBackupRegenerated: 'Backup codes regenerated',
  settings2faCodeRequired: 'Please enter a 6-digit code',
  settings2faDisableConfirm:
    'Are you sure you want to disable 2FA? This will reduce your account security.',
  settings2faRegenCodeRequired:
    'Please enter a 6-digit code to regenerate backup codes',

  // My Notification Settings Page
  myNotificationsTitle: 'My Notifications',
  myNotificationsSubtitle: 'Customize how and when you want to receive notifications',
  myNotificationsGlobalEnabled: 'You will receive notifications according to your configuration',
  myNotificationsGlobalDisabled: 'All notifications are paused',
  myNotificationsChannelsTitle: 'Notification Channels',
  myNotificationsChannelsSubtitle: 'Choose which channels you want to use for notifications',
  myNotificationsChannelPush: 'Push',
  myNotificationsChannelPushDescription: 'Real-time notifications',
  myNotificationsChannelEmail: 'Email',
  myNotificationsChannelEmailDescription: 'Email notifications',
  myNotificationsChannelInApp: 'In App',
  myNotificationsChannelInAppDescription: 'Notification center',
  myNotificationsChannelSMS: 'SMS',
  myNotificationsChannelSMSDescription: 'Text messages',
  myNotificationsChannelWhatsApp: 'WhatsApp',
  myNotificationsChannelWhatsAppDescription: 'WhatsApp messages',
  myNotificationsChannelUnavailable: 'Not available',
  myNotificationsEventsTitle: 'Notification Types',
  myNotificationsPriorityCritical: 'Critical',
  myNotificationsPriorityHigh: 'Important',
  myNotificationsEventDisabledByAdmin: 'Disabled by admin',
  myNotificationsQuietHoursTitle: 'Quiet Hours',
  myNotificationsQuietHoursSubtitle: 'Do not receive push notifications during these hours',

  // Notification Settings Page (admin)
  notificationSettingsTitle: 'Notification Settings',
  notificationSettingsSubtitle: 'Choose how you want to receive notifications for each event type',
  notificationSettingsInfoTitle: 'Notification Channels',
  notificationSettingsInfoText:
    'Email and Push are included in your plan. WhatsApp and SMS are premium services that require additional configuration.',
  notificationSettingsChannelsTitle: 'Available Channels',
  notificationSettingsChannelEmail: 'Organization Email',
  notificationSettingsChannelEmailDescription: 'Using your SMTP server',
  notificationSettingsChannelWhatsApp: 'WhatsApp Business',
  notificationSettingsChannelWhatsAppDescription: 'Via Twilio API',
  notificationSettingsChannelSMS: 'SMS',
  notificationSettingsChannelSMSDescription: 'Text messages',
  notificationSettingsChannelPush: 'Push Notifications',
  notificationSettingsChannelPushDescription: 'Browser / Mobile',
  notificationSettingsChannelInApp: 'In-App',
  notificationSettingsChannelInAppDescription: 'Always active',
  notificationSettingsMonthlyCost: '€{{amount}}/month',
  notificationSettingsConfigured: 'Configured',
  notificationSettingsRequires: 'Requires: {{requires}}',
  notificationSettingsWhatsAppTitle: 'Configure WhatsApp Business',
  notificationSettingsTwilioSidLabel: 'Twilio Account SID',
  notificationSettingsTwilioTokenLabel: 'Twilio Auth Token',
  notificationSettingsWhatsAppNumberLabel: 'WhatsApp Number (with country code)',
  notificationSettingsWhatsAppNumberHelp:
    'Twilio Sandbox number or your approved WhatsApp Business number',
  notificationSettingsWhatsAppSaved: 'Configuration saved. Send a test message to activate.',
  notificationSettingsTestTitle: 'Test Configuration',
  notificationSettingsTestPhoneRequired: 'Enter a phone number for the test',
  notificationSettingsSendTest: 'Send Test',
  notificationSettingsWhatsAppTestSuccess: 'WhatsApp activated successfully!',
  notificationSettingsWhatsAppTestError: 'Error during test',
  notificationSettingsWhatsAppSandboxHint:
    'The destination number must first send "join [sandbox-code]" to the Twilio number',
  notificationSettingsSetupTitle: 'How to configure?',
  notificationSettingsSetupStep1: 'Create an account on',
  notificationSettingsSetupStep2:
    'Activate the WhatsApp sandbox or request a WhatsApp Business number',
  notificationSettingsSetupStep3: 'Copy your credentials from the Twilio console',
  notificationSettingsSetupStep4: 'Send a test message to verify',
  notificationSettingsViewDocs: 'View documentation',
  notificationSettingsEmailHint:
    'Email is configured in the organization SMTP settings section.',
  notificationSettingsGoToSmtp: 'Go to SMTP Settings',
  notificationSettingsEventsTitle: 'Configure by Event',
  notificationSettingsEventsSubtitle: 'Select which channels to use for each type of notification',
  notificationSettingsEventShiftAssigned: 'Shift Assigned',
  notificationSettingsEventShiftAssignedDescription: 'When a shift is assigned to the employee',
  notificationSettingsEventShiftReminder: 'Shift Reminder',
  notificationSettingsEventShiftReminderDescription: 'Before the shift starts',
  notificationSettingsEventShiftCancelled: 'Shift Cancelled',
  notificationSettingsEventShiftCancelledDescription: 'When a shift is cancelled',
  notificationSettingsEventSwapRequest: 'Swap Request',
  notificationSettingsEventSwapRequestDescription: 'When someone requests a shift swap',
  notificationSettingsEventSwapApproved: 'Swap Approved',
  notificationSettingsEventSwapApprovedDescription: 'When a swap is approved',
  notificationSettingsEventSwapRejected: 'Swap Rejected',
  notificationSettingsEventSwapRejectedDescription: 'When a swap is rejected',
  notificationSettingsEventSchedulePublished: 'Schedule Published',
  notificationSettingsEventSchedulePublishedDescription: 'When the new schedule is published',
  notificationSettingsEventRuleViolation: 'Rule Violation',
  notificationSettingsEventRuleViolationDescription: 'Compliance alerts',
  notificationSettingsActivateChannelFirst:
    'First activate the {{channel}} channel to use it for this event.',
  notificationSettingsPricingTitle: 'Service Costs',
  notificationSettingsIncluded: 'Included',
  notificationSettingsServiceMonthly: '€{{amount}}/month',

  // Marketplace Page
  marketplaceTitle: 'Marketplace',
  marketplaceSubtitle: 'Exclusive benefits, extra shifts and salary advances',
  marketplaceTabPerks: 'Benefits & Discounts',
  marketplaceTabListings: 'Shift Marketplace',
  marketplaceTabAdvance: 'Salary Advance',
  marketplaceOverviewPartners: 'Partners',
  marketplaceOverviewActiveOffers: 'Active Offers',
  marketplaceOverviewFeatured: 'Featured',
  marketplaceOverviewMyRedemptions: 'My Redemptions',
  marketplaceSearchPlaceholder: 'Search offers...',
  marketplaceAllCategories: 'All categories',
  marketplaceCategoryFoodBeverage: 'Food & Beverage',
  marketplaceCategoryWellnessFitness: 'Wellness & Fitness',
  marketplaceCategoryEntertainment: 'Entertainment',
  marketplaceCategoryRetailShopping: 'Shopping',
  marketplaceCategoryTravelTransport: 'Travel & Transport',
  marketplaceCategoryEducationTraining: 'Education',
  marketplaceCategoryFinanceInsurance: 'Finance',
  marketplaceCategoryTechnology: 'Technology',
  marketplaceCategoryHealthMedical: 'Health',
  marketplaceCategoryOther: 'Other',
  marketplacePerkFeatured: 'FEATURED',
  marketplaceDiscountPercentage: '-{{value}}%',
  marketplaceDiscountFixed: '-${{value}}',
  marketplaceDiscountFree: 'FREE!',
  marketplaceRedeemOffer: 'Redeem Offer',
  marketplaceNoOffersTitle: 'No offers available',
  marketplaceNoOffersSubtitle: 'Exclusive benefits for you will be available soon.',
  marketplaceSeedDemo: 'Load Partners Demo',
  marketplaceRedeemError: 'Error redeeming offer',
  marketplaceDemoCreated:
    'Demo created: {{partners}} partners, {{perks}} perks',
  marketplaceDemoLoaded: 'Demo loaded',
  marketplaceApplySuccess: 'Application sent successfully!',
  marketplaceApplyError: 'Error applying',
  marketplaceListingsTitle: 'Shift Marketplace',
  marketplaceListingsSubtitle:
    'Cover shifts from other organizations and earn extra money. Great for additional income!',
  marketplaceListingUrgent: 'URGENT - ${{bonus}} BONUS',
  marketplaceListingRate: '${{rate}}/hr',
  marketplaceNoListingsTitle: 'No shifts available',
  marketplaceNoListingsSubtitle: 'Check back later for new opportunities!',
  marketplaceAdvanceMinError: 'The minimum advance is $20',
  marketplaceAdvanceSuccess:
    'An advance of ${{amount}} will be transferred!',
  marketplaceAdvanceError: 'Error requesting advance',
  marketplaceAdvanceAvailableTitle: 'Available for Advance',
  marketplaceAdvanceAvailableAmount: '${{amount}}',
  marketplaceAdvanceBasedOn:
    'Based on ${{wages}} earned wages ({{hours}} hours worked)',
  marketplaceAdvanceMaxTitle: 'Maximum advance',
  marketplaceAdvanceFee: 'Fee: {{fee}}%',
  marketplaceAdvanceRequestTitle: 'Request Advance',
  marketplaceAdvanceAmountLabel: 'Amount (min ${{min}})',
  marketplaceAdvanceInstantTransfer: 'Instant Transfer',
  marketplaceAdvanceBreakdown:
    'Fee: ${{feeAmount}} | You will receive: ${{netAmount}}',
  marketplaceAdvanceHistoryTitle: 'Advance History',
  marketplaceAdvanceHistoryRow: '${{amount}} requested',
  marketplaceAdvanceHistoryNet: '${{amount}} received',
  marketplaceAdvanceHistoryEmpty: 'You have no advance history yet',
  marketplaceCodeLabel: 'Your code:',
  marketplaceGoRedeem: 'Go to Redeem',
  marketplaceInstructionsLabel: 'Instructions:',

  // Labor Rules Page
  laborRulesTitle: 'Labor Rules',
  laborRulesSubtitle: 'Configure your organization\'s labor rules',
  laborRulesSaveSuccess: 'Labor rules saved successfully',
  laborRulesSaveError: 'Error saving labor rules',
  laborRulesBaseTemplateTitle: 'Base Template',
  laborRulesBaseTemplateDescription:
    'Select a template based on a country\'s legislation or fully customize the rules.',
  laborRulesTimeLimitsTitle: 'Time Limits',
  laborRulesMultipliersTitle: 'Cost Multipliers',
  laborRulesNightHoursTitle: 'Night Schedule',
  laborRulesMaxDailyHoursLabel: 'Maximum daily hours',
  laborRulesMaxDailyHoursDescription:
    'Maximum hours per shift (0 = no limit)',
  laborRulesMaxWeeklyHoursLabel: 'Maximum weekly hours',
  laborRulesMaxWeeklyHoursDescription: 'Maximum hours per week',
  laborRulesMaxAnnualOvertimeLabel: 'Maximum annual overtime hours',
  laborRulesMaxAnnualOvertimeDescription:
    'Maximum overtime hours per year (0 = no limit)',
  laborRulesMinRestBetweenShiftsLabel: 'Minimum rest between shifts',
  laborRulesMinRestBetweenShiftsDescription:
    'Minimum rest hours between shifts',
  laborRulesMinWeeklyRestLabel: 'Minimum weekly rest',
  laborRulesMinWeeklyRestDescription:
    'Minimum rest hours per week',
  laborRulesMaxConsecutiveDaysLabel: 'Maximum consecutive days',
  laborRulesMaxConsecutiveDaysDescription:
    'Maximum number of working days in a row',
  laborRulesMaxNightShiftsLabel: 'Maximum consecutive night shifts',
  laborRulesMaxNightShiftsDescription:
    'Consecutive night shifts (0 = no limit)',
  laborRulesUnitHoursShort: 'h',
  laborRulesUnitDays: 'days',
  laborRulesUnitNights: 'nights',
  laborRulesOvertimeMultiplierLabel: 'Overtime multiplier',
  laborRulesOvertimeMultiplierDescription: 'Ex: 1.5 = +50%',
  laborRulesNightMultiplierLabel: 'Night shift multiplier',
  laborRulesNightMultiplierDescription: 'Bonus for night shifts',
  laborRulesWeekendMultiplierLabel: 'Weekend multiplier',
  laborRulesWeekendMultiplierDescription: 'Bonus for Saturday/Sunday',
  laborRulesHolidayMultiplierLabel: 'Holiday multiplier',
  laborRulesHolidayMultiplierDescription: 'Bonus for public holidays',
  laborRulesNightStartLabel: 'Start',
  laborRulesNightEndLabel: 'End',
  laborRulesViolationsTitle: 'Detected Violations',
  laborRulesViolationsOpenCount: '{{count}} open',
  laborRulesNoViolationsTitle: 'No violations detected',
  laborRulesNoViolationsSubtitle: 'All shifts comply with the configured rules',

  // Integrations Page
  integrationsTitle: 'Integrations',
  integrationsSubtitle: 'Configure your third-party API keys',
  integrationsSensitiveInfoTitle: 'Sensitive Information',
  integrationsSensitiveInfoText:
    'API keys are stored securely and are never fully shown after saving. Only the Super Admin can modify these settings.',
  integrationsSaveSuccess: 'Configuration saved successfully!',
  integrationsSaveError: 'Error saving configuration',
  integrationsSaveButton: 'Save Configuration',
  integrationsStripeDescription: 'Payment processing',
  integrationsStripePublishableKeyLabel: 'Publishable Key (pk_...)',
  integrationsStripePublishableKeyPlaceholder: 'pk_live_... or pk_test_...',
  integrationsStripeSecretKeyLabel: 'Secret Key (sk_...)',
  integrationsStripeSecretKeyPlaceholder: 'sk_live_... or sk_test_...',
  integrationsStripeGetKeys: 'Get your keys at',
  integrationsTestConnection: 'Test Connection',
  integrationsStripeTestError: 'Error testing Stripe',
  integrationsAiTitle: 'Artificial Intelligence',
  integrationsAiSubtitle: 'Shift auto-assignment',
  integrationsAiProviderLabel: 'AI Provider',
  integrationsAiModelLabel: 'Model',
  integrationsAiApiKeyLabel: 'API Key',
  integrationsAiTestError: 'Error testing AI',
  integrationsCalendarTitle: 'Calendar Integrations',
  integrationsCalendarSubtitle:
    'Sync your shifts with Google Calendar and Microsoft Outlook/Teams',
  integrationsCalendarConnected:
    '{{provider}} connected successfully! {{email}}',
  integrationsCalendarConnectError: 'Error connecting calendar: {{error}}',
  integrationsCalendarStartError: 'Error starting calendar connection',
  integrationsCalendarDisconnectConfirm:
    'Do you want to disconnect {{provider}}?',
  integrationsCalendarDisconnected: '{{provider}} disconnected',
  integrationsCalendarDisconnectError: 'Error disconnecting calendar',
  integrationsCalendarConnectedAs: 'Connected as: {{email}}',
  integrationsCalendarSyncLabel: 'Sync: {{status}}',
  integrationsCalendarHowToTitle: 'How to configure calendar integrations?',
  integrationsGoogleDescription: 'Sync events and shifts',
  integrationsGoogleConnectText:
    'Connect your Google Calendar to automatically sync your work shifts.',
  integrationsGoogleBenefitUnified: 'See all your events in one place',
  integrationsGoogleBenefitBidirectional: 'Bidirectional sync',
  integrationsGoogleNotConfigured:
    'Google Calendar is not configured on the server. Contact the administrator.',
  integrationsGoogleConnectButton: 'Connect Google Calendar',
  integrationsMicrosoftTitle: 'Microsoft Outlook & Teams',
  integrationsMicrosoftDescription: 'Calendar and Teams meetings',
  integrationsMicrosoftConnectText:
    'Connect your Microsoft account to sync Outlook Calendar and automatically create Teams meetings.',
  integrationsMicrosoftBenefitOutlook: 'Sync with Outlook Calendar',
  integrationsMicrosoftBenefitTeams: 'Automatically create Teams meetings',
  integrationsMicrosoftBenefitBidirectional: 'Bidirectional sync',
  integrationsMicrosoftNotConfigured:
    'Microsoft is not configured on the server. Contact the administrator.',
  integrationsMicrosoftConnectButton: 'Connect Microsoft',
  integrationsCalendarGoogleStep1: 'Go to',
  integrationsCalendarGoogleStep2: 'Enable the Google Calendar API',
  integrationsCalendarGoogleStep3: 'Create OAuth 2.0 credentials',
  integrationsCalendarGoogleStep4: 'Set the environment variables:',
  integrationsCalendarMicrosoftStep1: 'Go to',
  integrationsCalendarMicrosoftStep2: 'Register an application in Azure AD',
  integrationsCalendarMicrosoftStep3:
    'Add permissions: Calendars.ReadWrite, User.Read',
  integrationsCalendarMicrosoftStep4: 'Set the environment variables:',

  // Incentives Page
  incentivesTitle: 'Incentives & Rewards',
  incentivesSubtitle: 'Earn points for your performance and redeem them for rewards',
  incentivesMyTotalPoints: 'My Total Points',
  incentivesCurrentRanking: 'Current ranking',
  incentivesTabHistory: 'History',
  incentivesTabRanking: 'Ranking',
  incentivesTabStore: 'Store',
  incentivesTabMyClaims: 'My Claims',
  incentivesNoPointsTitle: 'No points yet',
  incentivesNoPointsSubtitle: 'Earn points by being punctual and accepting extra shifts',
  incentivesNoRankingTitle: 'No ranking data',
  incentivesNoRankingSubtitle: 'The ranking will be generated when points are recorded',
  incentivesYouLabel: 'You',
  incentivesEmployeeLabel: 'Employee #{{rank}}',
  incentivesNoRewardsTitle: 'No rewards available',
  incentivesNoRewardsSubtitle: 'The administrator has not configured rewards yet',
  incentivesRewardAvailableCount: '{{count}} available',
  incentivesRewardNotEnoughPoints: 'Not enough points',
  incentivesRewardSoldOut: 'Sold out',
  incentivesRewardClaimButton: 'Redeem',
  incentivesRewardClaimed: 'Reward redeemed',
  incentivesRewardClaimError: 'Error redeeming reward',
  incentivesNoClaimsTitle: 'No claims',
  incentivesNoClaimsSubtitle: 'You have not redeemed any rewards yet',
  incentivesClaimPointsSpent: '{{points}} points',
  incentivesActiveProgramsTitle: 'Active Programs',

  // Geofencing Page
  geofencingTitle: 'Geofencing',
  geofencingSubtitle: 'Control attendance by location',
  geofencingNewLocationButton: 'New Location',
  geofencingCurrentLocationTitle: 'Your Current Location',
  geofencingCheckInZoneButton: 'Check if I am in zone',
  geofencingEnableLocationHint:
    'Enable location in your browser to use geofencing',
  geofencingLocationUnavailable: 'Could not get your location',
  geofencingCheckError: 'Error checking location',
  geofencingEditLocationTitle: 'Edit Location',
  geofencingNewLocationTitle: 'New Location',
  geofencingNameLabel: 'Name',
  geofencingNamePlaceholder: 'e.g. Headquarters',
  geofencingAddressLabel: 'Address',
  geofencingAddressPlaceholder: 'Street, number, city',
  geofencingUseCurrentLocation: 'Use my current location',
  geofencingRadiusLabel: 'Radius (meters)',
  geofencingRadiusShortLabel: 'Radius',
  geofencingRadiusHelp: 'Maximum allowed distance from the center point',
  geofencingPrimaryLocationLabel: 'Primary Location',
  geofencingPrimaryLocationHelp:
    'Will be used by default for verifications',
  geofencingNoLocationsTitle: 'No locations',
  geofencingNoLocationsSubtitle:
    'Add locations to control where your employees can clock in',
  geofencingAddFirstLocation: 'Add First Location',
  geofencingPrimaryLocationBadge: 'Primary Location',
  geofencingNoAddress: 'No address',
  geofencingCoordinatesLabel: 'Coordinates',
  geofencingMissingFieldsError: 'Complete all required fields',
  geofencingLocationUpdated: 'Location updated',
  geofencingLocationCreated: 'Location created',
  geofencingSaveError: 'Error saving location',
  geofencingDeleteConfirm: 'Delete this location?',
  geofencingLocationDeleted: 'Location deleted',
  geofencingDeleteError: 'Error deleting location',
  geofencingInsideArea: 'Inside allowed area',
  geofencingInsideAreaDetail: '{{name}} - {{distance}}m from center',
  geofencingOutsideArea: 'Outside allowed area',

  // Gamification Settings Page
  gamificationSettingsTitle: 'Gamification Settings',
  gamificationSettingsSubtitle: 'Configure rankings, points, rewards and weekly challenges',
  gamificationSettingsSaved: 'Gamification settings saved',
  gamificationSettingsSaveError: 'Error saving gamification settings',
  gamificationSettingsEnabled: 'Gamification activated',
  gamificationSettingsDisabled: 'Gamification deactivated',
  gamificationSettingsEnabledDescription:
    'Employees can earn points and compete for rewards',
  gamificationSettingsDisabledDescription:
    'Gamification is disabled for this organization',
  gamificationSettingsParticipationTotal: 'Total',
  gamificationSettingsParticipationConsented: 'Participating',
  gamificationSettingsParticipationOptedOut: 'Not participating',
  gamificationSettingsParticipationRate: 'Participation',
  gamificationSettingsRankingTitle: 'Ranking Configuration',
  gamificationSettingsRankingEnableLabel: 'Enable Ranking',
  gamificationSettingsRankingEnableDescription: 'Show employee leaderboard',
  gamificationSettingsRankingPeriodLabel: 'Ranking period',
  gamificationSettingsRankingVisibleLabel: 'Visible to everyone',
  gamificationSettingsRankingAnonymousLabel: 'Anonymous ranking',
  gamificationSettingsPointsTitle: 'Points System',
  gamificationSettingsPointsOnTimeLabel: 'Points for on-time clock-in',
  gamificationSettingsPointsPerfectWeekLabel: 'Points for perfect week',
  gamificationSettingsBonusStreakDaysLabel: 'Days for streak bonus',
  gamificationSettingsBonusStreakPointsLabel: 'Streak bonus points',
  gamificationSettingsChallengesTitle: 'Weekly Challenges ({{count}})',
  gamificationSettingsAddChallengeButton: 'Add Challenge',
  gamificationSettingsRewardsTitle: 'Rewards ({{count}})',
  gamificationSettingsAddRewardButton: 'Add Reward',
  gamificationSettingsRewardPositionLine:
    'Position {{position}}° • {{value}}',
  gamificationSettingsGdprTitle: 'Privacy & GDPR',
  gamificationSettingsGdprInfo:
    'GDPR compliance: Employees must give explicit consent to participate. They can opt-out at any time and request deletion of their data.',
  gamificationSettingsGdprRequireConsentLabel: 'Require consent',
  gamificationSettingsGdprRequireConsentDesc:
    'Employees must accept to participate',
  gamificationSettingsGdprAllowOptOutLabel: 'Allow opt-out',
  gamificationSettingsGdprAllowOptOutDesc:
    'Employees can leave the program',
  gamificationSettingsGdprAnonymizeAfterPeriodLabel: 'Anonymize old data',
  gamificationSettingsGdprAnonymizeAfterPeriodDesc:
    'After the retention period',
  gamificationSettingsGdprRetentionLabel: 'Data retention (days)',
  gamificationSettingsNewRewardTitle: 'New Reward',
  gamificationSettingsRewardNameLabel: 'Reward name',
  gamificationSettingsRewardNamePlaceholder: 'e.g. Employee of the Month',
  gamificationSettingsRewardDescriptionPlaceholder:
    'e.g. Best punctuality of the month',
  gamificationSettingsRewardValuePlaceholder: 'e.g. 1 day off, €50',
  gamificationSettingsNewChallengeTitle: 'New Challenge',
  gamificationSettingsChallengeNameLabel: 'Challenge name',
  gamificationSettingsChallengeNamePlaceholder: 'e.g. Perfect Punctuality',
  gamificationSettingsChallengeDescriptionPlaceholder:
    'e.g. Clock in on time 5 days in a row',
  gamificationSettingsChallengeTargetLabel: 'Target',
  gamificationSettingsChallengeRewardPointsLabel: 'Reward points',
  gamificationSettingsRewardAdded: 'Reward added',
  gamificationSettingsRewardAddError: 'Error adding reward',
  gamificationSettingsRewardDeleted: 'Reward deleted',
  gamificationSettingsChallengesUpdated: 'Challenges updated',
  gamificationSettingsChallengesSaveError: 'Error saving challenges',

  // Employee Onboarding Page
  onboardingTitle: 'Automated Onboarding',
  onboardingSubtitle:
    'Hire new employees with one click: OCR Scan → Contract → Digital Signature',
  onboardingNewHireButton: 'New Hire',
  onboardingStatTotalFlows: 'Total Processes',
  onboardingStatPending: 'Pending',
  onboardingStatAwaitingSignature: 'Awaiting Signature',
  onboardingStatCompleted: 'Completed',
  onboardingTabNew: 'New Hire',
  onboardingTabActive: 'In Progress',
  onboardingTabCompleted: 'Completed',
  onboardingStatusPendingIdScan: 'Pending Scan',
  onboardingStatusPendingReview: 'Under Review',
  onboardingStatusPendingContract: 'Generate Contract',
  onboardingStatusPendingSignature: 'Send for Signature',
  onboardingStatusAwaitingSignature: 'Awaiting Signature',
  onboardingSettingsSaved: 'Onboarding settings saved',
  onboardingNoFlowsTitle: 'No processes',
  onboardingNoCompletedFlows: 'No completed processes',
  onboardingNoActiveFlows: 'No active processes',
  onboardingOneClickTitle: 'One-Click Hiring',
  onboardingEmployeeEmailLabel: 'Employee Email',
  onboardingEmployeeEmailPlaceholder: 'new.employee@company.com',
  onboardingEmployeeNameLabel: 'Employee Name (optional)',
  onboardingEmployeeNamePlaceholder: 'Will be extracted from ID document',
  onboardingTemplateLabel: 'Contract Template',
  onboardingTemplatePlaceholder: 'Select template...',
  onboardingDocumentTypeLabel: 'Document Type',
  onboardingDocTypeDni: 'DNI (Spain)',
  onboardingDocTypeNie: 'NIE (Spain)',
  onboardingDocTypePassport: 'Passport',
  onboardingDocTypeDriverLicense: 'Driver\'s License',
  onboardingDocumentCountryLabel: 'Document Country',
  countryES: 'Spain',
  countryUS: 'United States',
  countryFR: 'France',
  countryDE: 'Germany',
  countryUK: 'United Kingdom',
  onboardingIdDocumentLabel: 'ID Document',
  onboardingUploadIdButton: 'Upload document photo',
  onboardingHumanReviewEnabledInfo:
    'Human review is enabled. The contract will require approval before being sent.',
  onboardingProcessingOcr: 'Processing OCR...',
  onboardingStartButton: 'Start Onboarding',
  onboardingResultTitle: 'Process Result',
  onboardingResultFlowId: 'Flow ID: {{id}}',
  onboardingExtractedDataTitle: 'Extracted Data (OCR)',
  onboardingNextStepsTitle: 'Next Steps',
  onboardingNextStepsReview:
    'Go to the "In Progress" tab to review and approve the extracted data.',
  onboardingNextStepsAutoSent:
    'The contract has been automatically sent for signature.',
  onboardingNextStepsSendForSignature:
    'Go to the "In Progress" tab to send the contract for signature.',
  onboardingEmptyResultTitle: 'Fill out the form and upload the document',
  onboardingEmptyResultSubtitle: 'Results will appear here',
  onboardingSettingsTitle: 'Onboarding Settings',
  onboardingSettingsHumanReviewLabel: 'Require Human Review',
  onboardingSettingsHumanReviewDescription:
    'OCR data must be approved before generating the contract',
  onboardingSettingsAutoSendLabel: 'Auto-send for Signature',
  onboardingSettingsAutoSendDescription:
    'Automatically send contract after it is generated',
  onboardingSettingsDefaultTemplateLabel: 'Default Template',
  onboardingSettingsDefaultTemplateNone: 'None (select each time)',
  onboardingSettingsDefaultCountryLabel: 'Default Country',
  onboardingSettingsOcrThresholdLabel: 'OCR Confidence Threshold: {{value}}%',
  onboardingFlowDetailTitle: 'Onboarding Process',
  onboardingApproveSuccess: 'Data approved',
  onboardingApproveError: 'Error approving data',
  onboardingGenerateContractSuccess: 'Contract generated',
  onboardingGenerateContractError: 'Error generating contract',
  onboardingSendForSignatureSuccess: 'Contract sent for signature',
  onboardingSendForSignatureError: 'Error sending contract',
  onboardingApproveAndContinueButton: 'Approve and Continue',
  onboardingGenerateContractButton: 'Generate Contract',
  onboardingSendForSignatureButton: 'Send for Signature',

  // Employee Credits Page
  employeeCreditsTitle: 'My Aria Credits',
  employeeCreditsSubtitle: 'Manage your credits to use the personal AI assistant',
  employeeCreditsBalanceLabel: 'Your Balance',
  employeeCreditsCreditsUnit: 'credits',
  employeeCreditsTotalPurchased: 'Total Purchased',
  employeeCreditsTotalUsed: 'Total Used',
  employeeCreditsPurchasesDisabledTitle: 'Purchases disabled',
  employeeCreditsPurchasesDisabledText:
    'Your organization does not allow employees to purchase credits directly. Contact your administrator if you need more credits.',
  employeeCreditsPurchasesDisabledOrg:
    'Your organization does not allow employees to purchase credits',
  employeeCreditsMonthlyLimitLine:
    'Monthly limit: {{limit}} credits',
  employeeCreditsRequiresApprovalSuffix:
    ' • Requires manager approval',
  employeeCreditsBuyTitle: 'Buy Credits',
  employeeCreditsPopularBadge: 'Popular',
  employeeCreditsSaveBadge: 'Save {{save}}',
  employeeCreditsBuyButton: 'Buy',
  employeeCreditsCreateSessionError: 'Error creating payment session',
  employeeCreditsWhatForTitle: 'What are credits for?',
  employeeCreditsUseChatTitle: 'Chat with Aria',
  employeeCreditsUseChatText:
    'Chat with your personal assistant for questions about shifts, policies, etc.',
  employeeCreditsUseChatCost: '~1 credit per message',
  employeeCreditsUseAnalysisTitle: 'Personalized Analysis',
  employeeCreditsUseAnalysisText:
    'Get insights on your work patterns and improvement suggestions.',
  employeeCreditsUseAnalysisCost: '~5 credits per analysis',
  employeeCreditsUseAvatarTitle: 'Animated Avatar',
  employeeCreditsUseAvatarText:
    'Interact with Aria through a real-time 3D animated avatar.',
  employeeCreditsUseAvatarCost: '~3 credits per minute',
  employeeCreditsPaymentsInfo:
    'All payments are processed securely on {{host}}',
  employeeCreditsPaymentsMethods:
    'We accept Visa, Mastercard, American Express and PayPal',

  // ERP Page
  erpLoadError: 'Error loading ERP data',
  erpSaveError: 'Error saving ERP data',
  erpTitle: 'ERP Premium',
  erpSubtitle: 'Advanced enterprise resource planning for your organization',
  erpNewExpenseButton: 'New Expense',

  erpUpgradeTitle: 'ERP Enterprise',
  erpUpgradeDescription:
    'The ERP module requires an Enterprise plan for full access to financial and planning resources.',
  erpUpgradeViewPlans: 'View Plans',

  erpTabDashboard: 'Dashboard',
  erpTabExpenses: 'Expenses',
  erpTabInventory: 'Inventory',
  erpTabSuppliers: 'Suppliers',
  erpTabOrders: 'Orders',
  erpTabCostCenters: 'Cost Centers',
  erpTabIntegration: 'Integration',
  erpTabReports: 'Reports',

  erpCategoryOperational: 'Operational',
  erpCategoryPayroll: 'Payroll',
  erpCategoryEquipment: 'Equipment',
  erpCategoryTravel: 'Travel',
  erpCategoryOther: 'Other',

  erpPremiumInventoryLine:
    '{{items}} items • {{alerts}} low stock alerts',
  erpPremiumCostCentersLabel: 'Cost Centers',
  erpPremiumCostCentersCount: '{{count}} centers',
  erpPremiumPendingOrdersLabel: 'Pending Orders',
  erpPremiumSuppliersCount: '{{count}} suppliers',
  erpPremiumIntegrationLabel: 'Integration',
  erpPremiumIntegrationDefaultProvider: 'Rostafy ERP',

  erpKpiEmployeesActive: 'Active Employees',
  erpKpiEmployeesHours: '{{hours}}h worked',
  erpKpiLaborCost: 'Labor Cost',
  erpKpiThisMonth: 'This month',
  erpKpiExpenses: 'Expenses',
  erpKpiExpensesCount: '{{count}} records',
  erpKpiPeriod: 'Period',
  erpKpiCurrentMonth: 'Current month',

  erpCostBreakdownTitle: 'Cost Breakdown',
  erpCostLaborLabel: 'Labor',
  erpCostOtherExpensesLabel: 'Other Expenses',

  erpKeyMetricsTitle: 'Key Metrics',
  erpMetricCostPerEmployee: 'Cost per Employee',
  erpMetricCostPerHour: 'Cost per Hour',
  erpMetricAvgHoursPerEmployee: 'Average Hours/Employee',

  erpNoExpenses: 'No expenses recorded',
  erpRegisterFirstExpense: 'Record first expense',
  erpExpensesDescriptionHeader: 'Description',
  erpExpensesCategoryHeader: 'Category',
  erpExpensesDateHeader: 'Date',
  erpExpensesAmountHeader: 'Amount',

  erpInventoryTotalValueLabel: 'Total Value',
  erpInventoryLowStockLabel: 'Low Stock',
  erpInventoryLowStockCount: '{{count}} items',
  erpInventoryNewItemButton: 'New Item',
  erpInventoryEmpty: 'No items in inventory',
  erpInventoryProductHeader: 'Product',
  erpInventorySkuHeader: 'SKU',
  erpInventoryQuantityHeader: 'Quantity',
  erpInventoryValueHeader: 'Value',

  erpSuppliersNewButton: 'New Supplier',
  erpSuppliersEmpty: 'No suppliers registered',
  erpSuppliersPaymentTerms: 'Terms: {{days}} days',

  erpOrdersEmpty: 'No purchase orders',
  erpOrdersItemsCount: '{{count}} items',

  erpCostCentersNewButton: 'New Cost Center',
  erpCostCentersEmpty: 'No cost centers',
  erpCostCentersUtilizationBadge: '{{value}}% used',
  erpCostCentersBudgetLabel: 'Budget',
  erpCostCentersSpentLabel: 'Spent: €{{amount}}',
  erpCostCentersRemainingLabel: 'Remaining: €{{amount}}',

  erpIntegrationTitle: 'ERP Integration Settings',
  erpIntegrationCurrentModeLabel: 'Current Mode',
  erpIntegrationExternalConnected: 'Connected to {{provider}}',
  erpIntegrationInternalMode: 'Using Rostafy internal ERP',
  erpIntegrationExternalTitle: 'Connect External ERP',
  erpIntegrationConnectWithProvider: 'Connect with {{provider}}',
  erpIntegrationNoErpTitle: "Don't have an ERP? Use ours",
  erpIntegrationNoErpDescription:
    'Rostafy integrated ERP includes all premium features with no extra configuration.',

  erpReportMonthlySummaryTitle: 'Monthly Summary',
  erpReportMonthlySummaryDescription:
    'Labor costs and expenses for the month',
  erpReportExpenseAnalysisTitle: 'Expense Analysis',
  erpReportExpenseAnalysisDescription: 'Breakdown by category',
  erpReportFinancialProjectionTitle: 'Financial Projection',
  erpReportFinancialProjectionDescription:
    'Estimate for the next quarter',
  erpReportInventoryTitle: 'Inventory',
  erpReportInventoryDescription: 'Valuation and movements',
  erpReportCostCentersTitle: 'Cost by Center',
  erpReportCostCentersDescription: 'Analysis by cost center',
  erpReportBalanceTitle: 'Balance Sheet',
  erpReportBalanceDescription: 'Full financial status',
  erpReportGenerateButton: 'Generate',

  // Domains Page
  domainsLoadError: 'Error loading domains',
  domainsAddError: 'Error adding domain',
  domainsVerifyError:
    'Error verifying domain. Please ensure DNS records are configured correctly.',
  domainsRemoveError: 'Error removing domain',
  domainsDeleteConfirm: 'Delete domain {{domain}}?',

  domainsTitle: 'Custom Domains',
  domainsSubtitle: 'Configure your own domain to access the platform',
  domainsAddButton: 'Add Domain',

  domainsInfoTitle: 'Custom Domain',
  domainsInfoDescription:
    'Configure a custom domain so your employees can access through your own URL. For example:',

  domainsStatusVerified: 'Verified',
  domainsStatusPending: 'Pending verification',
  domainsSslLabelPrefix: 'SSL:',
  domainsSslActive: 'Active',
  domainsSslPending: 'Pending',

  domainsDnsRequiredTitle: 'Required DNS Configuration',
  domainsDnsNameLabel: 'Name:',
  domainsDnsValueLabel: 'Value:',
  domainsDnsCnameDescription: 'Point your subdomain to our servers',
  domainsDnsTxtDescription: 'Domain ownership verification',
  domainsDnsFooterText:
    'After configuring the DNS records, click "Verify" to complete the setup. DNS propagation can take up to 48 hours.',

  domainsEmptyTitle: 'No domains configured',
  domainsEmptySubtitle:
    'Add a custom domain so your employees can access the platform with your own URL.',

  domainsFeatureSslTitle: 'Free SSL',
  domainsFeatureSslDescription:
    'Automatic SSL certificate included for your custom domain',
  domainsFeatureWhiteLabelTitle: 'White Label',
  domainsFeatureWhiteLabelDescription:
    'Your brand, your domain, with no Rostafy references',
  domainsFeatureCdnTitle: 'Global CDN',
  domainsFeatureCdnDescription:
    'Worldwide distribution for fast access from any location',

  domainsModalTitle: 'Add Domain',
  domainsModalDomainLabel: 'Domain',
  domainsModalDomainHelp:
    'Enter the subdomain or domain you want to use (without https://)',
  domainsModalNoteText:
    'After adding the domain, you must configure the DNS records in your domain provider.',
  domainsModalSubmitButton: 'Add',

  // Document Templates Page
  docTemplatesTitle: 'Document Templates',
  docTemplatesSubtitle:
    'Predefined templates by country, OCR for ID/Passport, and automatic autofill',
  docTemplatesOcrButton: 'Scan ID/Passport',
  docTemplatesNewTemplateButton: 'New Template',

  docTemplatesExtractedDataTitle: 'Automatically extracted data',
  docTemplatesExtractedDataLine:
    '{{count}} fields detected - Select a template to use this data',

  docTemplatesTabByCountry: 'Templates by Country',
  docTemplatesTabMyTemplates: 'My Templates',
  docTemplatesTabQuickGeneration: 'Quick Generation',

  docTemplatesNoCustomTitle: 'No custom templates',
  docTemplatesNoCustomSubtitle:
    'Create templates specific to your organization',
  docTemplatesCreateFirstButton: 'Create First Template',

  docTemplatesGenerateSuccess:
    'Document generated and sent for signature',
  docTemplatesCreateSuccess: 'Template created successfully',
  docTemplatesOcrSuccess: 'Data extracted successfully',

  docTemplatesCategoryEmploymentContract: 'Contract',
  docTemplatesCategoryPolicy: 'Policy',
  docTemplatesCategoryOther: 'Other',
  docTemplatesCustomBadge: 'Custom',
  docTemplatesMoreFieldsBadge: '+{{count}} more',

  docTemplatesPreviewButton: 'Preview',
  docTemplatesGenerateButton: 'Generate',

  docTemplatesQuickTitle: 'One-Click Quick Generation',
  docTemplatesQuickDescription:
    'Select an employee and a template. Data will be autofilled automatically and the document will be sent for signature.',
  docTemplatesQuickStepEmployee: '1. Select Employee',
  docTemplatesQuickEmployeePlaceholder: 'Choose employee...',
  docTemplatesQuickStepTemplate: '2. Select Template',
  docTemplatesQuickTemplatePlaceholder: 'Choose template...',
  docTemplatesQuickGenerateButton: 'Generate and Send',
  docTemplatesQuickExtractedNote:
    'Extracted data from the identity document will be included',
  docTemplatesRecentEmployeesTitle: 'Recent Employees',
  docTemplatesQuickMissingSelection:
    'Select employee and template',
  docTemplatesQuickSuccess:
    'Document generated successfully - Check in Digital Signatures',
  docTemplatesQuickError: 'Error generating document',

  docTemplatesOcrTitle: 'Scan Identity Document',
  docTemplatesOcrDocumentTypeLabel: 'Document Type',
  docTemplatesOcrDocTypeDni: 'DNI (Spain)',
  docTemplatesOcrDocTypeNie: 'NIE (Spain)',
  docTemplatesOcrDocTypePassport: 'Passport',
  docTemplatesOcrDocTypeDriverLicense: "Driver's License",
  docTemplatesOcrCountryLabel: 'Document Country',
  docTemplatesOcrImageLabel: 'Document Image',
  docTemplatesOcrUploadCta: 'Click to upload image',
  docTemplatesOcrNoteText:
    'Data is extracted automatically from the document. Review the information before generating contracts.',
  docTemplatesOcrExtractButton: 'Extract Data',

  // Compliance Page
  complianceLoadError: 'Error loading compliance data',
  complianceReportError: 'Error generating report',

  complianceTitle: 'SOC 2 Compliance',
  complianceSubtitle: 'Security monitoring and regulatory compliance',
  complianceGenerateReportButton: 'Generate Report',

  complianceScoreLabel: 'Compliance Score',
  complianceTwoFactorLabel: '2FA Enabled',
  complianceTwoFactorUsersLine:
    '{{enabled}}/{{total}} users',
  complianceAuditEvents24hLabel: 'Audit Events (24h)',
  complianceOpenEventsLabel: 'Open Events',
  complianceCriticalEventsLine:
    '{{count}} critical this week',

  complianceRecommendationsTitle: 'Recommendations',

  complianceTabSummary: 'Summary',
  complianceTabAudit: 'Audit Logs',
  complianceTabSecurity: 'Security Events',
  complianceTabAccess: 'Access Control',
  complianceTabRetention: 'Data Retention',

  complianceAuditTitle: 'Audit Log',
  complianceAuditDateHeader: 'Date',
  complianceAuditUserHeader: 'User',
  complianceAuditActionHeader: 'Action',
  complianceAuditResourceHeader: 'Resource',
  complianceAuditIpHeader: 'IP',
  complianceAuditEmpty: 'No audit log entries',

  complianceSecurityTitle: 'Security Events',
  complianceSecurityEmpty: 'No security events',

  complianceAccessTitle: 'Access Control Matrix (RBAC)',
  complianceAccessResourceHeader: 'Resource',

  complianceRetentionTitle: 'Data Retention Policies',
  complianceRetentionDays: '{{days}} days',

  complianceReportTitle: 'Compliance Report',

  // Compliance Alerts Page
  complianceAlertsTitle: 'Compliance Alerts',
  complianceAlertsSubtitle:
    'Receive notifications when employees are below the compliance threshold',
  complianceAlertsMainToggleTitle: 'Automatic Alerts',
  complianceAlertsDisabledSubtitle:
    'Automatic alerts are disabled',
  complianceAlertsFrequencyDaily: 'You will receive daily alerts',
  complianceAlertsFrequencyWeekly: 'You will receive weekly alerts',
  complianceAlertsFrequencyBiweekly: 'You will receive bi-weekly alerts',
  complianceAlertsFrequencyMonthly: 'You will receive monthly alerts',

  complianceAlertsSaveSuccess: 'Settings saved',
  complianceAlertsSaveError: 'Error saving settings',
  complianceAlertsEnabledMessage: 'Alerts enabled',
  complianceAlertsDisabledMessage: 'Alerts disabled',
  complianceAlertsSendError: 'Error sending alert',

  complianceAlertsLastAlertLine:
    'Last alert: {{date}} ({{count}} employees below {{threshold}}%)',

  complianceAlertsThresholdTitle: 'Alert Threshold',
  complianceAlertsThresholdLabel: 'Alert when compliance is lower than:',
  complianceAlertsThresholdRecommended: 'Recommended: 70%',
  complianceAlertsMinShiftsLabel: 'Minimum shifts to consider:',
  complianceAlertsMinShiftsOption1: '1 shift',
  complianceAlertsMinShiftsOption3: '3 shifts',
  complianceAlertsMinShiftsOption5: '5 shifts',
  complianceAlertsMinShiftsOption10: '10 shifts',
  complianceAlertsMinShiftsHelp:
    'Employees with fewer shifts will not be included in alerts',

  complianceAlertsFrequencyTitle: 'Frequency',
  complianceAlertsFrequencySendLabel: 'Send alerts:',
  complianceAlertsDayOfWeekLabel: 'Day of the week:',
  complianceAlertsTimeOfDayLabel: 'Send time:',

  complianceAlertsRecipientsTitle: 'Recipients',
  complianceAlertsOrgAdminsTitle: 'Organization Administrators',
  complianceAlertsOrgAdminsSubtitle: 'All admins will receive the alert',
  complianceAlertsDeptManagersTitle: 'Department Managers',
  complianceAlertsDeptManagersSubtitle:
    'Only for employees in their department',
  complianceAlertsAdditionalEmailsLabel: 'Additional emails:',
  complianceAlertsAdditionalEmailPlaceholder: 'email@example.com',

  complianceAlertsChannelsTitle: 'Delivery Channels',
  complianceAlertsChannelEmail: 'Email',
  complianceAlertsChannelInApp: 'In App',
  complianceAlertsChannelPush: 'Push',

  complianceAlertsContentTitle: 'Alert Content',
  complianceAlertsContentEmployeeDetailsLabel: 'Include employee details',
  complianceAlertsContentEmployeeDetailsDesc:
    'Name, department, compliance rate',
  complianceAlertsContentTrendLabel:
    'Include comparison with previous period',
  complianceAlertsContentTrendDesc:
    'Show whether it improved or worsened',
  complianceAlertsContentRecommendationsLabel: 'Include recommendations',
  complianceAlertsContentRecommendationsDesc:
    'Suggestions to improve compliance',

  complianceAlertsActionsTitle: 'Actions',
  complianceAlertsActionsSubtitle:
    'Preview or send an alert now',
  complianceAlertsPreviewButton: 'Preview',
  complianceAlertsSendNowButton: 'Send Now',

  complianceAlertsPreviewTitle: 'Alert Preview',
  complianceAlertsPreviewWouldSend:
    '⚠️ An alert would be sent: {{count}} employee(s) below {{threshold}}%',
  complianceAlertsPreviewWouldNotSend:
    '✅ No alert would be sent: All employees are within the threshold',
  complianceAlertsPreviewBelow: 'Below threshold',
  complianceAlertsPreviewAtRisk: 'At risk',
  complianceAlertsPreviewHealthy: 'Healthy',
  complianceAlertsPreviewEmployeesBelow:
    'Employees below {{threshold}}%:',
  complianceAlertsPreviewNoDepartment: 'No department',
  complianceAlertsPreviewShiftsLine: '{{shifts}} shifts',
  complianceAlertsPreviewRecipientsLabel: 'Recipients:',

  // Calendar OAuth Settings Page
  calendarOAuthTitle: 'Calendar Integrations (OAuth)',
  calendarOAuthSubtitle:
    'Configure OAuth credentials for bi-directional calendar sync',
  calendarOAuthInfoTitle: 'What is this for?',
  calendarOAuthInfoText:
    'With OAuth, employees can connect their personal Google or Microsoft calendars for bi-directional sync. Shifts are automatically created in their calendars and personal events can block availability.',

  calendarOAuthSaveSuccess: 'Configuration saved',
  calendarOAuthSaveError: 'Error saving configuration',
  calendarOAuthTestSuccess: 'Connection successful',
  calendarOAuthTestError: 'Connection error',

  calendarOAuthConnected: 'Connected',
  calendarOAuthClientIdLabel: 'Client ID',
  calendarOAuthClientSecretLabel: 'Client Secret',

  calendarOAuthGoogleTitle: 'Google Calendar',
  calendarOAuthGoogleSubtitle: 'Sync with Google Workspace accounts',
  calendarOAuthGoogleRedirectLabel:
    'Redirect URL (Authorized redirect URI):',
  calendarOAuthTestConnectionButton: 'Test Connection',
  calendarOAuthGoogleConsoleLink: 'Google Cloud Console',

  calendarOAuthMicrosoftTitle: 'Microsoft Outlook',
  calendarOAuthMicrosoftSubtitle: 'Sync with Microsoft 365 and Outlook',
  calendarOAuthMicrosoftAppIdLabel: 'Application (Client) ID',
  calendarOAuthTenantIdLabel: 'Tenant ID (optional)',
  calendarOAuthTenantHelp:
    'Use common to allow any account, or specify your tenant to restrict',
  calendarOAuthMicrosoftRedirectLabel:
    'Redirect URL (Redirect URI):',
  calendarOAuthAzurePortalLink: 'Azure Portal',

  calendarOAuthInstructionsTitle: 'Configuration Instructions',
  calendarOAuthInstructionsGoogleStep1: '1. Go to',
  calendarOAuthInstructionsGoogleStep2:
    '2. Create a new project or select an existing one',
  calendarOAuthInstructionsGoogleStep3:
    '3. Enable Google Calendar API',
  calendarOAuthInstructionsGoogleStep4:
    '4. Go to Credentials → Create credentials → OAuth client ID',
  calendarOAuthInstructionsGoogleStep5:
    '5. Configure the consent screen',
  calendarOAuthInstructionsGoogleStep6:
    '6. Add the redirect URI shown above',
  calendarOAuthInstructionsGoogleStep7:
    '7. Copy the Client ID and Client Secret here',

  calendarOAuthInstructionsMicrosoftStep1: '1. Go to',
  calendarOAuthInstructionsMicrosoftStep2:
    '2. Azure Active Directory → App registrations',
  calendarOAuthInstructionsMicrosoftStep3: '3. New registration',
  calendarOAuthInstructionsMicrosoftStep4:
    '4. Add the Redirect URI shown above',
  calendarOAuthInstructionsMicrosoftStep5:
    '5. In Certificates & secrets, create a new secret',
  calendarOAuthInstructionsMicrosoftStep6:
    '6. In API permissions, add Calendars.ReadWrite',
  calendarOAuthInstructionsMicrosoftStep7:
    '7. Copy the Application ID and Secret here',

  // CRM Page
  crmTitle: 'CRM',
  crmSubtitle: 'Customer relationship management',
  crmLoadError: 'Error loading CRM data',
  crmSaveError: 'Error saving record',
  crmMoveDealError: 'Error moving deal',

  crmUpgradeTitle: 'CRM Premium',
  crmUpgradeDescription:
    'The CRM module requires a Professional plan or higher to manage contacts and deals.',
  crmUpgradeViewPlans: 'View Plans',

  crmWsLive: 'Live',
  crmWsDisconnected: 'Disconnected',

  crmRealtimeTitle: 'Real-time activity',

  crmTabDashboard: 'Dashboard',
  crmTabContacts: 'Contacts',
  crmTabDeals: 'Deals',
  crmTabPipeline: 'Pipeline',

  crmDashboardContactsLabel: 'Contacts',
  crmDashboardContactsLine: '{{leads}} leads, {{customers}} customers',
  crmDashboardDealsLabel: 'Deals',
  crmDashboardPipelineLabel: 'Pipeline',
  crmDashboardWonLabel: 'Won',

  crmSearchContactsPlaceholder: 'Search contacts...',
  crmFilterAllStatuses: 'All statuses',
  crmStatusLead: 'Lead',
  crmStatusQualified: 'Qualified',
  crmStatusCustomer: 'Customer',
  crmStatusChurned: 'Churned',

  crmNoContacts: 'No contacts',
  crmCreateFirstContactButton: 'Create first contact',
  crmNoDeals: 'No deals',
  crmCreateFirstDealButton: 'Create first deal',

  crmPipelineHint:
    'Drag deals between stages to update their status',
  crmPipelineDropHere: 'Drop here',
  crmPipelineNoDeals: 'No deals',

  crmStageProspecting: 'Prospecting',
  crmStageQualification: 'Qualification',
  crmStageProposal: 'Proposal',
  crmStageNegotiation: 'Negotiation',
  crmStageWon: 'Won',
  crmStageLost: 'Lost',

  crmNewContactButton: 'New Contact',
  crmNewDealButton: 'New Deal',

  crmModalNewContactTitle: 'New Contact',
  crmModalNewDealTitle: 'New Deal',
  crmModalContactNameLabel: 'Name *',
  crmModalContactCompanyLabel: 'Company',
  crmModalContactStatusLabel: 'Status',
  crmModalDealNameLabel: 'Deal Name *',
  crmModalDealValueLabel: 'Value (€)',
  crmModalDealStageLabel: 'Stage',
  crmModalDealProbabilityLabel: 'Probability (%)',

  // Analytics Page
  analyticsTitle: 'Analytics Dashboard',
  analyticsSubtitle: 'Metrics and statistics for your organization',
  analyticsNoData: 'No data',

  analyticsPeriod7Days: 'Last 7 days',
  analyticsPeriod30Days: 'Last 30 days',
  analyticsPeriod90Days: 'Last 90 days',
  analyticsPeriod365Days: 'Last year',

  analyticsStatEmployeesActive: 'Active Employees',
  analyticsStatTotalShifts: 'Total Shifts',
  analyticsStatShiftsAssigned: '{{percent}}% assigned',
  analyticsStatSwaps: 'Swaps',
  analyticsStatSwapsApproved: '{{percent}}% approved',
  analyticsStatHoursWorked: 'Hours Worked',
  analyticsStatHoursTotal: 'total hours',

  analyticsWeeklyTrendsTitle: 'Weekly Trends',
  analyticsSwapsByStatusTitle: 'Swaps by Status',
  analyticsHoursByEmployeeTitle: 'Hours by Employee',
  analyticsHoursByEmployeeEmpty: 'No hours data',
  analyticsTemplateUsageTitle: 'Template Usage',
  analyticsTemplateUsageEmpty: 'No templates',

  analyticsRulesComplianceTitle: 'Rules & Compliance',
  analyticsRulesActiveLabel: 'Active Rules',
  analyticsRulesViolationsLabel: 'Violations',
  analyticsRulesComplianceRateLabel: 'Compliance Rate',

  analyticsDeploymentTitle: 'Dashboard Ready for Production',
  analyticsDeploymentText:
    'This dashboard is optimized for deployment on AWS + Cloudflare. Metrics update in real time and support large data volumes.',

  // AI Scheduling Page
  aiSchedulingTitle: 'AI Scheduling',
  aiSchedulingSubtitle: 'Intelligent optimization of shifts',

  aiSchedulingTabSuggest: 'Suggestions',
  aiSchedulingTabAutoAssign: 'Auto-Assign',
  aiSchedulingTabBalance: 'Balance',
  aiSchedulingTabPredict: 'Prediction',
  aiSchedulingTabOptimize: 'Optimize',

  aiSchedulingSuggestTitle: 'Get Suggestions',
  aiSchedulingSuggestDateLabel: 'Date',
  aiSchedulingSuggestPositionLabel: 'Position',
  aiSchedulingSuggestStartLabel: 'Start',
  aiSchedulingSuggestEndLabel: 'End',
  aiSchedulingSuggestButton: 'Get Suggestions',
  aiSchedulingSuggestEmpty:
    'Click "Get Suggestions" to see recommendations',
  aiSchedulingSuggestedEmployeesTitle: 'Suggested Employees',
  aiSchedulingSuggestNonCompliant: 'Does not meet all rules',
  aiSchedulingSuggestError: 'Error fetching suggestions',

  aiSchedulingAutoAssignTitle: 'Bulk Auto-Assign',
  aiSchedulingAutoAssignInfo:
    'This feature will automatically assign all unassigned shifts in the selected date range.',
  aiSchedulingAutoAssignButton: 'Run Auto-Assign',
  aiSchedulingAutoAssignResultTitle: 'Result',
  aiSchedulingAutoAssignTotalUnassigned: 'Total unassigned',
  aiSchedulingAutoAssignAssigned: 'Assigned',
  aiSchedulingAutoAssignFailed: 'Not assigned',
  aiSchedulingAutoAssignFailedShiftsTitle: 'Unassigned shifts:',
  aiSchedulingAutoAssignSuccess:
    '{{count}} shifts assigned automatically',
  aiSchedulingAutoAssignError: 'Error during auto-assignment',

  aiSchedulingBalanceTitle: 'Workload Balance',
  aiSchedulingBalanceEmployees: 'Employees',
  aiSchedulingBalanceAverage: 'Average',
  aiSchedulingBalanceBalanced: 'Balanced',
  aiSchedulingBalanceVariance: 'Variance',
  aiSchedulingBalanceOverworkedTitle: '⚠️ Overworked',
  aiSchedulingBalanceUnderworkedTitle: '💡 Available',
  aiSchedulingBalanceLoading: 'Loading analysis...',
  aiSchedulingBalanceError: 'Error analyzing balance',

  aiSchedulingPredictTitle: 'Staffing Prediction',
  aiSchedulingPredictDateLabel: 'Date to Predict',
  aiSchedulingPredictButton: 'Predict Needs',
  aiSchedulingPredictForDay: 'Prediction for {{day}}',
  aiSchedulingPredictShiftsRecommended: 'Recommended shifts',
  aiSchedulingPredictAvgHistorical: 'Historical average',
  aiSchedulingPredictTrendUp: '↑ Increasing',
  aiSchedulingPredictTrendDown: '↓ Decreasing',
  aiSchedulingPredictTrendStable: '→ Stable',
  aiSchedulingPredictTrendLabel: 'Trend',
  aiSchedulingPredictConfidenceLabel: 'Confidence:',
  aiSchedulingPredictionError: 'Error during prediction',

  aiSchedulingOptimizeTitle: 'Optimize Schedules',
  aiSchedulingOptimizeButton: 'Analyze Optimizations',
  aiSchedulingOptimizeSuggestionsTitle: 'Improvement Suggestions',
  aiSchedulingOptimizeSuggestionsBadge: '{{count}} improvements',
  aiSchedulingOptimizeCurrentScore: 'Current: {{score}}%',
  aiSchedulingOptimizeSuggestedScore: 'Suggested: {{score}}%',
  aiSchedulingOptimizeAlreadyOptimal: 'Schedules are already optimized!',
  aiSchedulingOptimizeSuccess:
    '{{count}} potential improvements found',
  aiSchedulingOptimizeError: 'Error during optimization',

  // Advanced Analytics Page
  advancedAnalyticsTitle: 'Advanced Analytics',
  advancedAnalyticsSubtitle: 'Industry insights, ROI analysis & predictions',
  advancedAnalyticsGdprTitle: 'GDPR/HIPAA Compliant:',
  advancedAnalyticsGdprText:
    'All analytics use anonymized, aggregated data only. No personal information is shared or exposed.',
  advancedAnalyticsTabBenchmarking: 'Industry Benchmarking',
  advancedAnalyticsTabRoi: 'ROI Calculator',
  advancedAnalyticsTabTurnover: 'Turnover Prediction',
  advancedAnalyticsBenchmarkPercentileTitle: 'Your Industry Percentile',
  advancedAnalyticsBenchmarkScoreTitle: 'Overall Score',
  advancedAnalyticsBenchmarkComparedTo: 'Compared to {{industry}} industry average',
  advancedAnalyticsBenchmarkYourValue: 'Your value',
  advancedAnalyticsBenchmarkIndustryAvg: 'Industry avg',
  advancedAnalyticsBenchmarkVsIndustry: 'vs industry',
  advancedAnalyticsRoiSavingsTitle: 'Your Estimated Annual Savings',
  advancedAnalyticsRoiText: 'Return on Investment',
  advancedAnalyticsRoiWithoutTitle: 'Without Rostafy',
  advancedAnalyticsRoiWithoutManagerTime: 'Manager scheduling time',
  advancedAnalyticsRoiWithoutSchedulingErrors: 'Scheduling errors',
  advancedAnalyticsRoiWithoutOvertimeCosts: 'Overtime costs',
  advancedAnalyticsRoiWithoutNoShowCosts: 'No-show costs',
  advancedAnalyticsRoiTotalMonthly: 'Total Monthly',
  advancedAnalyticsRoiWithTitle: 'With Rostafy',
  advancedAnalyticsRoiWithSubscription: 'Subscription',
  advancedAnalyticsRoiWithReducedOvertime: 'Reduced overtime',
  advancedAnalyticsRoiWithReducedNoShows: 'Reduced no-shows',
  advancedAnalyticsRoiEfficiencyTitle: 'Efficiency Gains',
  advancedAnalyticsRoiEfficiencySavedWeekly: 'Saved weekly',
  advancedAnalyticsRoiEfficiencyFewerErrors: 'Fewer errors',
  advancedAnalyticsRoiEfficiencyLessOvertime: 'Less overtime',
  advancedAnalyticsRoiEfficiencyFewerNoShows: 'Fewer no-shows',
  advancedAnalyticsTurnoverRetentionTitle: 'Team Retention Score',
  advancedAnalyticsTurnoverTeamSize: 'Team Size',
  advancedAnalyticsTurnoverHighRiskTitle: 'High Risk Employees',
  advancedAnalyticsTurnoverEmployees: 'employees',
  advancedAnalyticsTurnoverEstimatedTitle: 'Estimated Annual Turnover',
  advancedAnalyticsTurnoverLikelyToLeave: 'employees likely to leave',
  advancedAnalyticsTurnoverRiskTitle: 'Risk Distribution',
  advancedAnalyticsTurnoverRiskLow: 'Low',
  advancedAnalyticsTurnoverRiskModerate: 'Moderate',
  advancedAnalyticsTurnoverRiskHigh: 'High',
  advancedAnalyticsTurnoverPrivacyTitle: 'Privacy Notice:',
  
  // Missingkeys 1.0  
  selectOrganization: 'Select Organization',
  selectOrganizationToViewEmployees: 'Please select an organization to view employees',
  selectOrganizationToViewSettings: 'Please select an organization to view settings',
  selectOrganizationToViewSettingsDescription: 'Select an organization from the dropdown above to view and manage its settings.',
  selectOrganizationToViewShifts: 'Please select an organization to view shifts',
  aiAssignment: 'AI Assignment',
  settingsTabPassword: 'Password',
  
  settingsSecurityProceedToDashboard: 'Proceed to Dashboard',
  copyAll: 'Copy All',
  copied: 'Copied!',

  enterBackupCode: 'Enter one of your 8-character backup codes',
  
  
  // Password subsection
  settingsPasswordTitle: 'Change Password',
  settingsPasswordDescription: 'Update your login password for this account.',
  settingsPasswordCurrentLabel: 'Current password',
  settingsPasswordNewLabel: 'New password',
  settingsPasswordConfirmLabel: 'Confirm new password',
  settingsPasswordHint: 'Use at least 12 characters, including letters, numbers and symbols.',
  settingsPasswordRequired: 'Please fill in all password fields.',
  settingsPasswordMismatch: 'New passwords do not match.',
  settingsPasswordSuccess: 'Your password has been changed successfully.',
  settingsPasswordError: 'Error changing password',
  settingsPasswordSaveButton: 'Save password',
  settingsPasswordChangeRequiredBannerTitle: 'Password Change Required',
  settingsPasswordChangeRequiredBannerText: 'You must change your temporary password before accessing the system. Please change your password below.',

  // Change Password Required Page
  changePasswordRequiredTitle: 'Change Your Password',
  changePasswordRequiredDescription: 'You must change your temporary password before accessing the system.',
  changePasswordRequiredNewPasswordLabel: 'New Password',
  changePasswordRequiredNewPasswordPlaceholder: 'Enter new password',
  changePasswordRequiredConfirmPasswordLabel: 'Confirm New Password',
  changePasswordRequiredConfirmPasswordPlaceholder: 'Confirm new password',
  changePasswordRequiredSubmitButton: 'Change Password',
  changePasswordRequiredSuccess: 'Password changed successfully!',
  changePasswordRequiredError: 'Failed to change password. Please try again.',
  changePasswordRequiredNewPasswordRequired: 'Please enter a new password',
  changePasswordRequiredConfirmRequired: 'Please confirm your password',
  changePasswordRequiredMismatch: 'Passwords do not match',
  changePasswordRequiredWeakPassword: 'Please fix password errors before submitting',
  changePasswordRequiredValidPassword: '✓ Password meets requirements',
  changePasswordRequiredPasswordsMatch: '✓ Passwords match',
  changePasswordRequiredSecurityNote: 'For security reasons, you must change your temporary password before accessing the system.',
  changePasswordRequiredMinLength: 'Password must be at least 12 characters',
  changePasswordRequiredUppercase: 'Password must contain at least one uppercase letter',
  changePasswordRequiredLowercase: 'Password must contain at least one lowercase letter',
  changePasswordRequiredSpecialChar: 'Password must contain at least one special character',
  
  
  // 2FA required screen / admin banner
  settingsSecurityForce2faMessage: 'Your organization requires 2FA. Please complete setup to continue.',
  settingsSecurityForce2faIntro:
    'Click the button below to generate your 2FA QR code and scan it with your authenticator app.',
  settingsSecurityAdminBannerTitle: 'Your organization enforces 2FA for all users.',
  settingsSecurityAdminBannerText:
    'For maximum security and to avoid lockout scenarios, we strongly recommend enabling 2FA for your own admin account as well.',
  settingsSecurityForce2faLabel: 'Require 2FA for all users in this organization',
  settingsSecurityForce2faDescription:
    'When enabled, non-admin users (managers and workers) must configure 2FA after login before accessing the dashboard.',
  settingsSecurityForce2faEnabled: 'Forced 2FA has been enabled for this organization.',
  settingsSecurityForce2faDisabled: 'Forced 2FA has been disabled for this organization.',
  settingsSecurityForce2faError: 'Error updating Force 2FA setting',
  

};
